export default {
  hrbee_packages: {
    assets: 'Modul za imovinu',
    employee: 'Modul za zaposlene',
    feeds: 'Modul za obaveštenja',
    recruitment: 'Modul za regrutaciju',
    vacations: 'Modul za odmore',
    wages: 'Modul za plate',
    workschedule: 'Modul za raspored rada',
    insurance: 'Modul za osiguranje',
    performance: 'Modul za performanse'
  },

  hrbee_packages_descriptions: {
    assets: 'Modul za imovinu',
    employee: 'Modul za zaposlene',
    feeds: 'Modul za obaveštenja',
    recruitment: 'Modul za regrutaciju',
    vacations: 'Modul za odmore',
    wages: 'Modul za plate',
    workschedule: 'Modul za raspored rada',
    insurance: 'Modul za osiguranje',
    performance: 'Modul za performanse'
  },
  common: {
    yes: 'Da',
    no: 'Ne',
    nodatafound: 'Nema podataka',
    edit: 'Izmeni'
  },
  extra: {
    banktransfer: 'Bankovni transfer',
    date: 'Datum',
    time: 'Vreme',
    type: 'Tip',
    description: 'Opis',
    cforcandidate: 'Komentar za kandidata',
    cbycandidate: 'Komentari od kandidata'
  },

  cancel_job: {
    cancel_job_vacancy: 'Otkaži konkurs za posao',
    reason_of_job_cancelation:
      'Molimo napišite razlog za otkazivanje konkursa za posao',
    candidates_will_be_informed:
      'Svi kandidati koji su se prijavili biće obavešteni o razlogu otkazivanja',
    no_access: 'Nema pristupa'
  },

  all_notifications: {
    on: 'na',
    at: 'u',
    mark_all_as_read: 'Označi sve kao pročitano',
    no_notifications: 'Nemate novih obaveštenja',

    invited_to_interview: 'vas je pozvao na intervju za',
    approved_application: 'odobrio vašu prijavu za',
    rejected_application: 'odbio vašu prijavu za',
    rated_cv: 'ocenio vaš CV na',

    invite_interview: 'Pozovite na intervju',
    job_app_accepted: 'Prijava za posao je prihvaćena',
    job_app_rejected: 'Prijava za posao je odbijena',
    job_app_rated: 'Prijava za posao je ocenjena',

    applied_for: 'prijavio se za',
    accepted_interview: 'prihvatio intervju',
    rejected_interview: 'odbio intervju',
    requested_vacation: 'zatražio odmor.',
    new_invoice: 'Imate novu fakturu',
    for_your_company: ' za vašu kompaniju',
    approved_module: 'Hr Bee je odobrio modul za ',
    rejected_module: 'Hr Bee je odbio modul za ',

    new_application: 'Nova prijava za posao',
    interview_accepted: 'Intervju prihvaćen',
    interview_rejected: 'Intervju odbijen',
    vacation_request: 'Zahtev za odmor',
    invoice: 'Faktura',
    new_module: 'Novi modul',
    reject_module: 'Odbijeni modul',

    approved_vacation_request: 'odobrio vaš zahtev za odmor',
    department_lead_approved_vacation_request:
      '{departmentLeadName} je odobrio zahtev za odmor {targetEmployeeName}, čekajući vašu odluku',
    approved_vacation: 'odobrio vam odmor',
    rejected_vacation_request: 'odbio vaš zahtev za odmor',

    vacation_approved: 'Odmor odobren',
    vacation_rejected: 'Odmor odbijen',
    vacation: 'Odmor',

    access_control_absence:
      'Sistem je pronašao odsustvo iz vašeg radnog rasporeda'
  },

  salary_page: {
    primaryjob: 'Primarni posao',
    secondaryjob: 'Sekundarni posao',
    terminationpay: 'Otpremnina'
  },

  attendance: {
    map: 'Koordinate lokacije',
    checkinlocation: 'Lokacija prijave',
    checkoutlocation: 'Lokacija odjave',
    delete: 'Obriši',
    get_reports_button: 'Preuzmi izveštaje',
    work_duration: 'Trajanje rada',
    pause_duration: 'Trajanje pauze',
    checkin: 'Prijava',
    checkout: 'Odjava',
    type: 'Tip',
    duration: 'Trajanje',
    work: 'Rad',
    pause: 'Pauza',
    add_attendance: 'Dodaj',
    add_attendance_description: 'Dodaj radne sate',
    today_attendances: 'Danas prisutnosti',
    today_schedule: 'Danas raspored',
    weekly_schedules: 'Nedeljni rasporedi',
    monthly_attendances: 'Mesečne prisutnosti'
  },

  workschedule: {
    download_daily_reports: 'Preuzmi dnevne izveštaje',
    download_monthly_reports: 'Preuzmi mesečne izveštaje',
    accesscontrolreports: 'Izveštaji o kontroli pristupa',
    nologs: 'Još uvek nema podataka za ovog korisnika',
    date: 'Datum',
    checkin: 'Prijava',
    checkout: 'Odjava',
    checkedin: 'Prijavljeno',
    checkedout: 'Odjavljeno',
    byschedulecheckin: 'Prijava po rasporedu',
    byschedulecheckout: 'Odjava po rasporedu',
    workinghours: 'Radni sati',
    workedhours: 'Odrađeni sati',
    absences: 'Odsustva',
    absencenotes: 'Napomene o odsustvu',
    editabsence: 'Izmeni odsustvo',
    reasons: 'Razlozi',
    noreason: 'Nema navedenog razloga',
    deductfrompay: 'Oduzmi od plate',
    deductfrompayamount: 'Iznos za oduzimanje',
    markasresolved: 'Označi kao rešen',
    details: 'Detalji',
    minutes: 'minute',
    type: 'Tip',
    totalworkinghours: 'Ukupno radnih sati: ',
    totalabsencehours: 'Ukupno sati odsustva: ',
    totalbreakhours: 'Ukupno sati pauze: ',
    closedetails: 'Zatvori detalje',
    addnewschedule: 'Dodaj novu šablon rasporeda',
    back: 'Nazad',
    name: 'Ime',
    select_schedule_template: 'Izaberite šablon rasporeda',
    workingschedule: 'Radni raspored',
    works: 'Radovi',
    nowork: 'Nema rada',
    start: 'Početak',
    end: 'Kraj',
    monday: 'Ponedeljak',
    tuesday: 'Utorak',
    wednesday: 'Sreda',
    thursday: 'Četvrtak',
    friday: 'Petak',
    saturday: 'Subota',
    sunday: 'Nedelja',
    save: 'Sačuvaj',
    cancel: 'Otkaži',
    edit: 'Izmeni',
    update: 'Ažuriraj',
    delete: 'Obriši',
    noschedule: 'Nema šablona rasporeda, molimo dodajte novi',
    noemployee: 'Nemate nijednog zaposlenog dodatog'
  },

  emp_pages: {
    no_general_vacations: 'Nema opštih odmora od kompanije',
    departments: 'Odeljenja',
    department: 'Odeljenje',
    position: 'Pozicija',
    subdepartments: 'Pododeljenja',
    subsubdepartments: 'Podpododeljenja',
    positions: 'Pozicije',
    nodresscode: 'Nema pravila oblačenja',
    nodresscodedsc:
      'Idite u podešavanja naloga i dodajte nova pravila oblačenja',
    nodresscodewithsearch:
      'Nema pravila oblačenja koja odgovaraju ovom filteru',
    filter: 'Filter',
    clearfilter: 'Očisti filter'
  },

  accsettings_alert: {
    old_pass_wrong: 'Stara lozinka treba da bude ispravna!',
    pass_changed_success:
      'Lozinka je uspešno promenjena, molimo vas da se ponovo prijavite!',
    confirm_pass_wrong: 'Potvrda lozinke treba da bude ista kao nova lozinka!'
  },

  employeeNavigation: {
    feeds: 'Izvori',
    profile: 'Profil',
    vacations: 'Odmori',
    salaries: 'Plate',
    workingschedule: 'Radni raspored',
    workschedule: 'Raspored rada',
    myschedule: 'Moj raspored',
    performance: 'Performanse',
    events: 'Događaji',
    todos: 'Obaveze',
    companyorganogram: 'Organogram kompanije',
    dresscode: 'Pravila oblačenja',
    regulation: 'Regulativa'
  },

  employmentTypes: {
    full_time: 'Puno radno vreme',
    part_time: 'Polu radno vreme',
    remote: 'Daljinski',
    temporary: 'Privremeno',
    contracted: 'Ugovorno',
    internship: 'Praktikantski',
    seasonal: 'Sezonski',
    volunteer: 'Volonterski'
  },

  navigationCompany: {
    assets: 'Imovina',
    asset_categories: 'Kategorije',
    support: 'Podrška - Često postavljana pitanja',
    newsfeed: 'Vesti',
    recruitment: 'Regrutacija',
    jobs: 'Poslovi',
    interviews: 'Intervjui',
    ratings: 'Ocene',
    blacklist: 'Crna lista',
    jobstemplate: 'Šablon poslova',
    searchingemployees: 'Pretraga zaposlenih',
    reports: 'Izveštaji',
    employees: 'Zaposleni',
    dashboard: 'Kontrolna tabla',
    allemployees: 'Svi zaposleni',
    documenttemplates: 'Šabloni dokumenata',
    employeeContract: 'Ugovori zaposlenih',
    birthdays: 'Rođendani',
    performanceSettings: 'Podešavanja performansi',
    workschedule: 'Radni raspored',
    all_employees: 'Svi zaposleni',
    schedule_template: 'Šablon rasporeda',
    vacations: 'Odmori zaposlenih',
    vacationrequest: 'Zahtevi za odmor zaposlenih',
    publicholidays: 'Državni praznici',
    generalvacations: 'Opšti odmori',
    finances: 'Finansije',
    employeesalaries: 'Plate zaposlenih',
    generatesalaries: 'Generisanje plata',
    wages: 'Beneficije i naknade',
    timelineproject: 'Projekti na vremenskoj liniji',
    training: 'Obuka',
    insurance: 'Osiguranje',
    performance: 'Performanse',

    attendances_settings: 'Podešavanja Prisustva',

    workschedule_today: 'Današnja prisustva',

    performance_templates: 'Šabloni performansi',
    all_employee_performances: 'Performanse svih zaposlenih',

    paymentsettings: 'Podešavanja plaćanja',

    generatewages: 'Generisanje zarada',
    bonuses: 'Bonusi',
    employeeswages: 'Zarade zaposlenih',
    settings: 'Podešavanja'
  },

  alertscompany: {
    job_addeed: 'Vaš posao je uspešno dodat',
    job_cantadded: 'Molimo popunite sva obavezna polja (*)',
    job_edited: 'Vaš posao je uspešno ažuriran',
    rated_added: 'Uspešno ste ocenili ovog kandidata',
    addcancelreason: 'Molimo dodajte razlog otkazivanja',
    invitedtointerview: 'Poziv za intervju je uspešno poslat kandidatu',
    cantadd: 'Molimo popunite sva obavezna polja (*)',
    rejectedcandidate: 'Odbili ste kandidata za ovu poziciju',
    blacklistedcandidate: 'Dodali ste kandidata na crnu listu',
    hiredcandidate:
      'Uspešno ste zaposlili kandidata, idite u modul za zaposlene da završite proces zapošljavanja',
    potentialcandidate: 'Kandidat je dodat na listu potencijalnih kandidata'
  },

  jobStatusTypes: {
    status: 'Status posla',
    active: 'Aktivan',
    draft: 'Nacrt',
    canceled: 'Otkazano',
    finished: 'Završeno',
    cancel_job: 'Otkaži posao'
  },

  performance: {
    add: 'Dodaj',
    performances_list_for_section: 'Performanse ovog odeljka:',
    no_sections_created_yet:
      'Još nije kreiran nijedan odeljak performansi za vašu poziciju',
    section_no_performance:
      'Još nije kreirana nijedna performansa za ovaj odeljak',
    select_month_to_see_ratings:
      'Ako želite da vidite ocene performansi, molimo prvo odaberite mesec',
    performances_employee_title: 'Ocena performansi',
    performances_employee_description:
      'Ispod možete pronaći vaše performanse ocenjivanja na osnovu odeljaka',
    show_history: 'Prikaži istoriju ocenjivanja',
    hide_history: 'Sakrij istoriju ocenjivanja',
    for_this_section_there_are: 'Za ovaj odeljak i izabrani mesec postoje',
    performances_to_rate_employee:
      'performanse koje možete oceniti za vašeg zaposlenog',
    already_rated_for_this_month:
      'Već ste ocenili ovog zaposlenog za izabrani mesec u ovom odeljku, proverite sada istoriju ->',
    please_select_month:
      'Molimo odaberite mesec da ocenite vašeg zaposlenog za ovaj odeljak',
    no_performances_for_this_section: 'Još nema performansi za ovaj odeljak',
    rating_history: 'Istorija ocenjivanja',
    performance: 'Performansa',
    rate_for_section: 'Ocenite za ovaj odeljak',
    performance_sections: 'odeljci performansi',
    section: 'odeljak',
    percentage_in_total_of_section: 'u ukupnom iznosu izabranog odeljka',
    of_section: 'odeljka',
    add_performance_for_section: 'Dodaj performansu za odeljak',
    rate_type: 'Tip ocenjivanja',
    list_of_performances_for_title: 'Lista performansi za izabrani odeljak',
    list_of_performances_for_description:
      'Lista performansi za izabrani odeljak',
    add_performance_for_section_title: 'Dodaj performansu za izabrani odeljak',
    add_performance_for_section_description:
      'Dodaj performansu za izabrani odeljak',
    performances: 'Performanse',
    add_section_performance: 'Dodaj odeljak',
    percentage_of_section: 'Procenat odeljka u šablonu performansi',
    in_total_perfomance: 'u ukupnoj performansi',
    add_performance_button: 'Dodaj performansu',
    add_performance_title: 'Kreiraj kriterijum performansi',
    add_performance_description: 'Ugovor sa zaposlenima',
    add_performance_section_title: 'Kreiraj odeljak',
    add_performance_section_description:
      'Kreiraj odeljak sa kriterijumima performansi',
    rating_item_type_numbers_title: 'Mera ocene performansi',
    rating_item_type_numbers_description: 'Meri performansu kroz ocenjivanje',

    rating_item_type_scale_title: 'Rating measure performance',
    rating_item_type_scale_description:
      'Meri performansu kroz ocenjivanje od 1 do 5',
    rating_item_type_percentage_title: 'Poređenje mera performansi',
    rating_item_type_percentage_description:
      'Ovaj kriterijum može se koristiti za merenje nivoa dostignuća u poređenju',
    target_you_achived: 'Cilj koji ste postigli',
    target_you_have: 'Cilj koji imate',
    taget_you_achived_percentage: 'Cilj koji ste postigli u %',
    rating_item_type_text_title: 'Tekstualni okvir',
    rating_item_type_text_description:
      'Zaposleni mogu pisati ono što imaju da kažu uopšte',
    alert_select_type_of_rating: 'Molimo odaberite jedan od tipova ocenjivanja',
    performance_templates: 'šabloni performansi',
    performance_page_title: 'Performanse zaposlenih',
    performance_page_description:
      'Ispod možete pronaći vaše zaposlene, možete odabrati jednog od njih i oceniti performansu',
    no_templates_available_for_current_position_of_employee:
      'Nema dostupnih šablona performansi za trenutnu poziciju ovog zaposlenog. Molimo idite na Šabloni performansi i kreirajte jedan.',
    month: 'Mesec',
    year: 'Godina',
    text: 'Tekst'
  },

  month_value: {
    1: 'Januar',
    2: 'Februar',
    3: 'Mart',
    4: 'April',
    5: 'Maj',
    6: 'Jun',
    7: 'Jul',
    8: 'Avgust',
    9: 'Septembar',
    10: 'Oktobar',
    11: 'Novembar',
    12: 'Decembar'
  },

  job_aplication_status: {
    applied_on: 'Prijavljen na',
    rate_candidate: 'Oceni',
    change_status: 'Promeni status',
    interview_details: 'Detalji intervjua',
    blacklisted_details: 'Detalji o crnoj listi',
    refuse_candidate_application_details:
      'Detalji o odbijanju prijave kandidata',
    reason_for_blacklist: 'Razlog zašto ste stavili kandidata na crnu listu',
    reason_for_decline: 'Razlog za odbijanje prijave kandidata',
    interview_category: 'Vrsta intervjua',
    in_person_interview: 'Intervju uživo',
    phone_call: 'Telefonski poziv',
    online_interview: 'Online intervju',
    interview_date: 'Datum intervjua',
    interview_time: 'Vreme intervjua',
    interview_description: 'Opis intervjua',
    interview_comments: 'Komentari intervjua',
    new_application: 'Nova prijava',
    rejected_candidate: 'Odbij prijavu',
    invited_to_interview: 'Pozvan na intervju',
    blacklisted: 'Crna lista',
    accepted_interview: 'Prihvati intervju',
    rejected_interview: 'Odbij intervju',
    potential_candidate: 'Potencijalni kandidat',
    hired_candidate: 'Zaposlen kandidat',
    job_seeker_reference_letter: 'Preporuke',
    job_seeker_reference_letter_doesnt_exists: 'Preporuke nisu dodate',
    job_seeker_cover_letter: 'Prateće pismo',
    job_seeker_cover_letter_doesnt_exists: 'Prateće pismo nije dodato'
  },

  company_jobs_page: {
    exportjobdetails: 'Izvoz detalja posla',
    need_to_be_approved:
      'Oglas za posao mora biti odobren od strane administratora',
    approved: 'Oglas za posao je odobren i objavljen',
    filterjobsbtn: 'Filtriraj poslove',
    cancelbtn: 'Otkaži',
    addnewjobbtn: 'Dodaj novi posao',
    titlejob: 'Naziv',
    statusjob: 'Status posla: ',
    ongoing: 'U toku',
    pending: 'Na čekanju',
    canceled: 'Otkazano',
    completed: 'Završeno',
    published: 'Objavljeno',
    typejob: 'Tip posla',
    deadline: 'Rok',
    applications: 'Prijave',
    viewcandidates: 'Pogledaj kandidate',
    editinterviewpanel: 'Izmeni panel',
    selectinterviewpanelmember: 'Izaberite članove panela za intervju',
    editvacancy: 'Izmeni oglas',
    deletevacancy: 'Izbriši',

    nojobspublished: 'Još nemate objavljenih poslova',
    nojobsbysearch: 'Nema posla prema ovoj pretrazi',
    searchjobplaceholder: 'Pretraži posao i pritisni enter',
    searchcandidateplaceholder: 'Ime i prezime kandidata',
    namesurname: 'Ime i Prezime',
    email: 'Email adresa',
    phonenumber: 'Broj telefona (+383XXXXXXXX)',

    filterjobs: 'Filtriraj poslove',
    filterjobsdsc: 'Pripremite svoje poslove koristeći ove filtere',
    filterbystatus: 'Filtriraj prema statusu',
    filterbystatusph: 'Izaberi status',
    filterbyyear: 'Filtriraj prema godini',
    filterbyyearph: 'Izaberi godinu',
    filterbymonth: 'Filtriraj prema mesecu',
    filterbymonthph: 'Izaberi mesec',
    filterbytype: 'Filtriraj prema tipu',
    filterbytypeph: 'Izaberi tip',
    applyfiltersbtn: 'Primeni filtere',

    filtercandidates: 'Filtriraj kandidate',
    filtercandidatesdsc:
      'Pripremite svoju listu kandidata koristeći ove filtere',
    filterbygender: 'Filtriraj prema polu',
    filterbygenderph: 'Izaberi pol',
    filterbyeducation: 'Filtriraj prema obrazovanju',
    filterbyeducationph: 'Izaberi nivo obrazovanja',
    filterbyfieldofstudy: 'Filtriraj prema oblasti studija',
    filterbyfieldofstudyph: 'Izaberi oblast studija',
    filterbyskills: 'Filtriraj prema veštinama',
    filterbyskillsph: 'Izaberi veštinu',
    filterbyrate: 'Filtriraj prema oceni',
    filterbyrateph: 'Izaberi ocenu',
    filterbylanguages: 'Filtriraj prema jezicima',
    filterbylanguagesph: 'Izaberi jezik',
    filterbyyearsofexperience: 'Filtriraj prema godinama iskustva',
    filterbyyearsofexperienceph: 'Izaberi godine iskustva',
    filterbymotivationletter: 'Filtriraj prema motivacionom pismu',
    filterbymotivationletterph: 'Prikaži kandidate sa motivacionim pismom',
    filterbyreferenceletter: 'Filtriraj prema pismu preporuke',
    filterbyreferenceletterph: 'Prikaži kandidate sa pismom preporuke',

    clearfiltersbtn: 'Obriši filtere',
    clearfilters: 'Obriši filtere',
    backbtn: 'Nazad',

    selectedcandidate: 'Izabrani kandidati',
    rejectedcandidate: 'Odbijeni kandidat',
    potentialcandidates: 'Potencijalni kandidati',

    appliedon: 'Prijavljen: ',
    invitedforinterview: 'Pozvan na intervju',
    interviewaccepted: 'Kandidat je prihvatio intervju',
    rejectedcandidatebycompany: 'Kandidat odbijen od strane kompanije',
    rejectedinterview: 'Intervju odbijen od strane kandidata',
    blacklistedcandidate: 'Kandidat na crnoj listi',
    ratedcandidate: 'Ocenjen kandidat',
    hiredcandidate: 'Zaposlen kandidat',
    potentialcandidate: 'Potencijalni kandidat',

    sorrynojobapplications: 'Nažalost, nemate nijednu prijavu za posao',

    titlecandidate: 'Naziv',
    birthday: 'Datum rođenja',
    citycountry: 'Grad i zemlja',
    socialmedia: 'Društvene mreže: ',
    shortbio: 'Kratka biografija: ',

    experience: 'Iskustvo',
    noexperience: 'Nema dodatog iskustva',
    education: 'Obrazovanje',
    schoolname: 'Naziv škole',
    fieldofstudy: 'Oblast studija',
    fromupto: 'od - do',
    levelofeducation: 'Nivo obrazovanja',
    file: 'Fajl',
    noeducation: 'Nema dodatog obrazovanja',

    trainings: 'Obuke',
    institution: 'Institucija',
    trainingcourse: 'Obuka / Kurs',
    notrainings: 'Nema dodatih obuka',

    languages: 'Jezici',
    language: 'Jezik',
    reading: 'Čitanje',
    understanding: 'Razumevanje',
    speaking: 'Govor',
    writing: 'Pisanje',
    nolanguages: 'Nema dodatih jezika',

    itskills: 'IT veštine',
    skill: 'Veština',
    level: 'Nivo',
    noitskills: 'Nema dodatih računarskih veština',

    otherskills: 'Ostale veštine',
    nootherskills: 'Nema dodatih veština',

    drivinglicence: 'Vozačka dozvola',
    nootherdrivinglicence: 'Nema dodatih veština vožnje',

    referenceletter: 'Pismo preporuke',
    noreferenceletter: 'Nema dodatog pisma preporuke',

    requiredreferenceandmotivation:
      'Ako želite pismo preporuke i motivaciono pismo, molimo vas da izaberete',
    motivationletter: 'Motivaciono pismo',
    nomotivationletter: 'Nema dodatog motivacionog pisma',

    rateeducation: 'Oceni obrazovanje',
    ratelanguages: 'Oceni jezike',
    rateexperience: 'Oceni iskustvo',
    profileexperience: 'Profil iskustva',
    generalknowledge: 'Opšte znanje',
    judgementcapability: 'Sposobnost procene',
    knowledgeaboutposition: 'Znanje o poziciji',
    logicalquestions: 'Logička pitanja',
    totalaveragerating: 'Ukupan prosek',
    ratecandidate: 'Oceni kandidata',
    noteforcandidate: 'Napomena za kandidata',
    finaldecision: 'Konačna odluka',

    publishjobbtn: 'Objavi posao',
    saveastemplatebtn: 'Sačuvaj kao šablon',

    previewofjobtemplate: 'Pregled šablona posla',
    titleofjobtemplate: 'Naslov šablona posla',

    editjob: 'Izmeni posao',
    updatejob: 'Ažuriraj posao',

    viewblacklistedcandidates: 'Pogledaj kandidate na crnoj listi',
    noblacklistedcandidate: 'Nemate kandidata na crnoj listi',
    reason: 'Razlog: ',
    details: 'Detalji',
    viewapplication: 'Pogledaj prijavu',
    removefromblacklist: 'Ukloni sa crne liste',

    viewratedcandidates: 'Pogledaj ocenjene kandidate',
    noratedcandidate: 'Nemate ocenjenih kandidata',

    viewinterviewcandidates: 'Pogledaj kandidate za intervju',
    nointerviewcandidate: 'Nemate kandidata za intervju',

    noinvitedcandidate: 'Nemate pozvanih kandidata',
    noacceptcandidate: 'Nijedan kandidat nije prihvatio poziv za intervju',
    norejectcandidate: 'Nijedan kandidat nije odbio poziv za intervju',
    nointerviewcandidatewithsearch: 'Nema kandidata sa tim imenom',

    invitedinterview: 'Pozvani na intervju',
    acceptinterview: 'Prihvaćeni intervjui',
    rejectinterview: 'Odbijeni intervjui',

    usethistemplate: 'Koristi ovaj šablon',
    notemplate: 'Nemate nijedan šablon za posao',

    noteaboutcandidate: 'Napomena o kandidatu'
  },

  company_blacklist: {
    reason: 'Razlog',
    jobseekername: 'Ime sa crne liste',
    jobseekeremail: 'Email sa crne liste',
    jobseekerphonenumber: 'Broj telefona sa crne liste',
    usersblacklisted: 'Korisnici na crnoj listi',
    numberofusersblacklisted: 'Broj korisnika na crnoj listi',
    viewusers: 'Pogledaj korisnike',
    createblacklist: 'Kreiraj crnu listu',
    editblacklist: 'Izmeni crnu listu',
    deleteblacklist: 'Izbriši crnu listu',
    removeuserseditwarning:
      'Izmena ove crne liste će ukloniti korisnike sa liste, da li ste sigurni?',
    removeusersdeletewarning:
      'Brisanje ove crne liste će ukloniti korisnike sa liste, da li ste sigurni?',
    userremoved: 'Korisnik uspešno uklonjen sa crne liste',
    noblacklistedusers: 'Nema korisnika na crnoj listi',
    createnewblacklistforremovedusers:
      'Kreiraj novu crnu listu za ove korisnike',
    noblacklists: 'Nemate nijednu crnu listu'
  },

  invite_manual_section: {
    invitemanual: 'Ručno pozivanje',
    invitejobseekermanual: 'Ručno pozovi tražioca posla',
    experience: 'Iskustvo',
    stillworking: 'Još uvek radi',
    notworking: 'Ne radi',
    cancel: 'Otkaži',
    invitenow: 'Pozovi sada'
  },

  salaryTypes: {
    salary_net: 'Neto plata',
    salary_bruto: 'Bruto plata',
    GROSS: 'Bruto plata',
    NET: 'Neto plata',
    null: 'Tip plate'
  },

  VacationLeaveTypes: {
    yearly_leave: 'Godišnji odmor',
    sick_leave: 'Bolovanje',
    marriage_leave: 'Odmor za venčanje',
    maternity_leave: 'Porodiljsko odsustvo',
    daily_leave: 'Dnevno odsustvo',
    death_leave: 'Odsustvo zbog smrti',
    paternity_leave: 'Odsustvo za očeve',
    blood_donation_leave: 'Odsustvo za donaciju krvi',
    compensation_leave: 'Odsustvo kao kompenzacija',
    overtime: 'Prekovremeni rad',
    unpaid_leave: 'Neplaćeno odsustvo'
  },

  assets: {
    image: 'Slika',
    add: 'Dodaj',
    change: 'Promeni',
    status: 'Status',
    available: 'Dostupno',
    assigned: 'Dodeljeno',
    in_maintenance: 'Na održavanju',
    retired: 'Povučeno',
    current_status: 'Trenutni status',
    unique_identifier: 'Jedinstveni identifikator',
    identifier_input_mode: 'Unos identifikatora',
    identifier_mode_auto: 'Automatski generiši',
    identifier_mode_manual: 'Ručno unesi',
    identifier_auto_placeholder: 'Identifikator će biti automatski generisan',
    identifier_auto_help:
      'Jedinstveni identifikator će biti generisan kada sačuvate imovinu.',
    qr_code: 'QR kod',
    qr_code_description:
      'Skenirajte ovaj QR kod da pročitate jedinstveni identifikator imovine.',
    qr_code_not_available: 'QR kod nije dostupan za ovu imovinu.',
    download_qr_code: 'Preuzmi QR kod',
    print_qr_code: 'Odštampaj QR kod',
    export_available: 'Izvezi dostupno',
    export_assigned: 'Izvezi dodeljeno',
    export_current_view: 'Izvezi trenutni prikaz',
    export_all: 'Izvezi sve',
    export_assets: 'Izvezi u Excel',
    exporting_assets: 'Izvoz u toku...',
    created_date: 'Datum kreiranja',
    no_assets_to_export: 'Nema imovine za izvoz.',
    filter_by_status: 'Filtriraj po statusu',
    all_statuses: 'Svi statusi',
    available_assets: 'Dostupna imovina',
    unassigned_assets: 'Nedodeljena imovina',
    assigned_assets: 'Dodeljena imovina',
    search_assets: 'Pretraži imovinu po nazivu ili identifikatoru',
    search_assets_placeholder: 'Pretraži',
    search_results: 'Rezultati pretrage',
    no_search_results: 'Nije pronađena imovina za trenutne filtere.',
    filter_by_category: 'Filtriraj po kategoriji',
    clear_filters: 'Obriši filtere',
    rows_per_page: 'Redova po stranici',
    deleted_category: 'Obrisana kategorija',
    select_asset_category: 'Izaberi kategoriju imovine',
    category_name: 'Ime kategorije',
    new_asset_category: 'Nova kategorija imovine',
    assets: 'Imovina',
    asset: 'Imovina',
    new_asset: 'Registruj imovinu',
    assign_asset: 'Dodeli imovinu',
    select_asset: 'Izaberi imovinu',
    assignment_date: 'Datum dodele',
    return_date: 'Datum vraćanja',
    return_asset: 'Vrati imovinu',
    note: 'Napomena',
    no_data: 'Nema registrovane imovine',
    title: 'Naslov',
    serial_number: 'Serijski broj',
    edit_asset: 'Izmeni imovinu',
    delete_asset: 'Obriši imovinu',
    assigned_to: 'Dodeljeno',
    asset_history: 'Istorija imovine'
  },

  employee_module: {
    vacation: 'Odmor',
    contract_number: 'Broj ugovora',
    startjoblaterthan: 'Početak posla najkasnije',
    calculateVacationUnusedDays: 'Izračunaj neiskorišćene dane odmora',
    deadline: 'Rok',
    markedascompleted: 'Označeno kao završeno',
    createtodo: 'Kreiraj zadatak',
    title: 'Naslov',
    description: 'Opis',
    todos: 'Zadaci',
    notodosfound: 'Nema kreiranih zadataka za ovog zaposlenog',
    phonenumber: 'Broj telefona',
    salaryamount: 'Iznos plate',
    monthly_working_days: 'Mesečni radni dani',
    job_description: 'Opis posla',
    accesscontrolid: 'ID kontrole pristupa',
    requestdate: 'Datum zahteva',
    vacationyear: 'Godina odmora',
    editdocumenttemplate: 'Izmeni šablon dokumenta',
    delete: 'Obriši',
    download: 'Preuzmi',
    notapproved: 'Nije odobreno',
    startdatevacation: 'Datum početka odmora',
    enddatevacation: 'Datum završetka odmora',
    totaldays: 'Ukupno dana',
    total_days: 'Ukupno dana',
    selectvacationtemplate: 'Izaberi šablon odmora',
    married: 'U braku',
    not_married: 'Nije u braku',
    addnewdocument: 'Dodaj novi dokument',
    expire: 'Datum isteka',
    expiry_date: 'Datum isteka',
    nogeneralvacations: 'Nema opštih odmora za vašu kompaniju',
    nogeneralvacationsdsc: 'Molimo idite u modul odmora i dodajte opšte odmore',
    yes: 'Da',
    no: 'Ne',
    addthisemployeetowageslist: 'Dodaj zaposlenog na listu plata',
    issecondjob: 'Da li je ovo sekundarni posao?',
    healthinsurancemonthlycost: 'Mesečni trošak zdravstvenog osiguranja',
    newemployeebtn: 'Dodaj novog zaposlenog',
    noemployee: 'Nemate dodatih zaposlenih',
    applyfilters: 'Primeni filtre',
    apply: 'Primeni',

    addnewtemplate: 'Dodaj novi šablon',
    doctemplates: 'Šabloni dokumenata',
    contracttemp: 'Šabloni ugovora',
    vacationstemp: 'Šabloni odmora',
    warninglettertemp: 'Šabloni opomena',
    sorrynotemp: 'Nemate nijedan šablon dokumenta',

    profilecv: 'Profil CV',
    employeeinfo: 'Informacije o zaposlenom',
    contract: 'Ugovor',
    contracthistory: 'Istorija ugovora',
    vacations: 'Odmori',
    performance: 'Performanse',
    salary: 'Plata',
    warningletter: 'Pismo upozorenja',
    otherdocuments: 'Ostali dokumenti',
    access: 'Pristup',

    personalinformation: 'Lične informacije',
    accountinformation: 'Informacije o računu',
    pw: 'Generiši novu lozinku i pošalji email',
    changepw: 'Promeni lozinku',
    employeeworking: 'Zaposleni trenutno radi u našoj kompaniji',
    female: 'Ženski',
    male: 'Muški',

    bankinformation: 'Informacije o banci',
    bankname: 'Ime banke',
    banknumber: 'Broj bankovnog računa',
    banknamedc: 'Ime banke...',

    emergencyinformation: 'Informacije u hitnim slučajevima',
    bloodgroup: 'Krvna grupa',
    bloodgroupdc: 'Izaberi krvnu grupu',
    contactperson: 'Osoba za kontakt',
    contactpersondc: 'Ime kontakt osobe...',
    contactpersonphone: 'Telefon kontakt osobe',
    contactpersonphonedc: 'Telefon kontakt osobe...',

    booktimeoff: 'Zakaži slobodno vreme',
    booktimeofffromcompany:
      'Kao kompanija možete zakazati slobodno vreme za zaposlenog direktno i odobriti ga',
    editvacation: 'Izmeni odmor zaposlenog',
    editvacationdc: 'Kao kompanija možete izmeniti slobodno vreme zaposlenog',
    vacationtype: 'Vrsta odmora',
    selectvacationtype: 'Izaberi vrstu odmora',
    vacationreplacedby: 'Zamenjeno sa',
    selectvacationreplacedby: 'Izaberite osobu koja će vas zameniti',
    startdate: 'Datum početka',
    enddate: 'Datum završetka',
    halfday: 'Samo treba pola dana slobodno',
    reason: 'Razlog',
    reasondc: 'Molimo unesite razlog odmora...',

    contractstartdate: 'Datum početka ugovora',
    contractenddate: 'Datum završetka ugovora',
    contractenddatetoggle: 'Ugovor na neodređeno vreme',
    indefiniteterm: 'Na neodređeno vreme',
    chooseposition: 'Izaberi poziciju',
    from: 'Od',
    upto: 'Do',
    workplace_location: 'Lokacija radnog mesta',
    employmenttype: 'Tip zaposlenja',
    current_address: 'Trenutna adresa',
    country: 'Država',
    city: 'Grad',
    birthday: 'Rođendan',

    contractinformation: 'Informacije o ugovoru',
    salaryinformation: 'Informacije o plati',
    paymentcurrency: 'Valuta isplate',
    selectpaymentcurrency: 'Izaberite valutu isplate',
    paymentcurrencyhelp:
      'Izaberite valutu koja se koristi za ovog zaposlenog pre obračuna zarade.',
    paymentcurrencyrequired: 'Valuta isplate je obavezna.',
    salary_range_allowed: 'Dozvoljeni raspon: {min} - {max} {currency}',

    performancetools: 'Alati za performanse',
    addnewperformance: 'Dodaj novu performansu',
    editperformancebtn: 'Izmeni',
    deleteperformancebtn: 'Obriši',
    performancerating: 'Ocena merenja performansi',
    performanceratingdc: 'Merite performanse ocenom',
    noperformance: 'Nemate dodatih performansi',
    noperformancedc:
      'Da biste dodali ocenu performansi zaposlenika, prvo morate kreirati konfiguraciju za vaše performanse',
    performancename: 'Naslov',
    performanceratinginterval: 'Koliko često treba ocenjivati zaposlene?',
    selecttypeperformance: 'Izaberi tip performanse',
    performancetype: 'Tip performanse: ',
    rateperformance: 'Oceni performansu',
    yearforrating: 'Godina za ocenjivanje',
    yearforratingdc: 'Izaberi godinu za ocenjivanje',
    monthforrating: 'Mesec za ocenjivanje',
    monthforratingdc: 'Izaberi mesec za ocenjivanje',

    addemployees: 'Dodaj zaposlene',
    addemployeesdsc:
      'Dodajte svoje zaposlene putem ovih opcija klikom na dugmadi',
    byrecruitment: 'Preko regrutacije',
    manual: 'Ručni',

    nojobseekerwithhiredstatus: 'Nema tražilaca posla sa statusom zaposlen',

    personalinfo: 'Lične informacije',
    accinfor: 'Informacije o računu',

    idcardno: 'ID zaposlenog',
    idcardnodc: 'Broj lične karte',
    department: 'Odeljenje',
    position: 'Pozicija',
    accemail: 'Email korisnika',
    startjob: 'Početak posla',
    phone: 'Broj telefona',
    personalid: 'Lični ID',

    hirethisemployee: 'Zaposli ovog zaposlenog',

    filteremployees: 'Filtriraj zaposlene',
    clearfilters: 'Obriši filtre',
    filteremployeesdc: 'Pripremamo vašu listu zaposlenih kroz te filtre',

    filterbydepartment: 'Filtriraj po odeljenju',
    filterbyposition: 'Filtriraj po poziciji',
    filterbygender: 'Filtriraj po polu',
    filterbycity: 'Filtriraj po gradu',

    generatesalary: 'Generiši platu',
    salaryfor: 'Plata za',
    salarytype: 'Tip plate',
    grosssalary: 'Bruto plata',
    taxes: 'Porezi',
    rankjob: 'Rang posla',
    primaryjob: 'Primarni posao',
    secondaryjob: 'Sekundarni posao',
    date: 'Datum',
    contribution: 'Doprinos',
    totaltax: 'Ukupni porez',
    netsalary: 'NET plata',
    nosalarygenerated: 'Ovaj zaposleni nema generisanih plata',

    editmonthly: 'Izmeni detalje mesečnog izveštaja',
    selectyear: 'Izaberi godinu',
    selectmonth: 'Od meseca',
    formonth: 'Za mesec',
    selecttomonth: 'Do meseca',
    isthissecondaryjob: 'Da li je ovo sekundarni posao?',
    advancedpayment: 'Avansna isplata',
    leavewithoutpayment: 'Odsustvo bez plate',
    bonuspayment: 'Bonus isplata',
    savereport: 'Sačuvaj izveštaj',

    nodocuments: 'Nemate dodatih dokumenata',

    selectcontract: 'Izaberi ugovor',
    selectwarningletter:
      'Izaberi pismo upozorenja iz svojih šablona dokumenata',

    nameandsurname: 'Ime i prezime',
    personalID: 'Lični ID',
    employeeID: 'ID zaposlenog',
    address: 'Adresa',
    startdatecontract: 'Datum početka ugovora',
    enddatecontract: 'Datum završetka ugovora',
    ceo: 'CEO',
    fiscalnumber: 'Fiskalni broj',
    companyaddress: 'Adresa kompanije',
    companycity: 'Compani citi',
    headofhr: 'Šef HR-a',

    contracttermination: 'Prekid ugovora',
    contractterminationbtn: 'Prekini ugovor',
    editcontractterminationbtn: 'Izmeni detalje prekida ugovora',
    contractterminationgrosspay: 'Bruto isplata pri prekidu',
    contractterminationreason: 'Razlog za prekid',

    leavehistory: 'Istorija odsustava za ovu godinu',
    noleaves: 'Nema odsustava za ovu godinu',

    genderstatistics: 'Statistika pola',
    marriagestatistics: 'Statistika braka',
    nationalitystatistics: ''
  },

  alerts_employee_module: {
    update_document_template: 'Šablon dokumenta uspešno ažuriran',
    update_employee: 'Informacije o zaposlenom uspešno ažurirane',
    vacationfromcompany: 'Zakaženo slobodno vreme je uspešno sačuvano',
    vacationdaysexist: 'Već su zatraženi datumi za odmor',
    rateperformance: 'Uspešno ste ocenili performanse ovog kandidata',
    newemployee: 'Uspešno je angažovan novi zaposleni',
    emailunique: 'Ova email adresa je već zauzeta',
    deletetemplate: 'Šablon uspešno obrisan',
    somethingwentwrong: 'Došlo je do greške, molimo pokušajte ponovo',
    templateadded: 'Šablon dokumenta uspešno dodat'
  },

  payroll_currency: {
    confirm_single_employee_mismatch:
      'Ovaj zaposleni koristi drugu valutu isplate. Da li želite da nastavite sa konverzijom?',
    confirm_multiple_employee_mismatch:
      'Neki zaposleni koriste drugu valutu isplate. Da li želite da nastavite sa konverzijom?',
    shown_in: 'Prikazano u',
    converted_from: 'Konvertovano iz',
    conversion_rate: 'Kurs konverzije'
  },

  inputs_employee_module: {
    title: 'Naslov',
    type: 'Tip',
    selecttype: 'Izaberite tip',
    templatecolumns: 'Broj kolona'
  },

  employee_access: {
    access: 'Postavite pristup ovog zaposlenog',
    selectpackage: 'Izaberite paket',
    accesstype: 'Tip pristupa',
    accessdepartments: 'Pristup odeljenjima',
    selectaccesstype: 'Izaberite tip pristupa',
    accessread: 'Čitanje',
    accesswrite: 'Pisanje',
    isadmin: 'Da li je administrator'
  },

  alerts_employee_access: {
    nopackageselected: 'Morate izabrati paket',
    accessupdated: 'Pristup zaposlenog je ažuriran'
  },

  vacations_module: {
    print: 'Štampaj',
    vacationyear: 'Godina odmora',
    vacationmonth: 'Mesec odmora',
    publicholidays: 'Državni praznici',
    nopublicholiday: 'Nema dodanih državnih praznika',
    addnewholiday: 'Dodaj novi državni praznik',
    editholiday: 'Izmeni državni praznik',
    edit: 'Izmeni',
    delete: 'Obriši',
    createholiday: 'Kreiraj novu datum praznika',
    createholidaysdsc:
      'Upišite naziv i datum praznika za kreiranje novih praznika',
    holidayname: 'Naziv praznika',
    holidaydate: 'Datum praznika',

    right_to_use_next_year:
      'Preostali dani odmora mogu se iskoristiti sledeće godine?',

    generalvac: 'Opšti odmor',
    addnewvac: 'Dodaj novi odmor',
    editvac: 'Izmeni odmor',
    createvacation: 'Kreiraj novi odmor',
    createvacationdsc:
      'Ispunite polja i kreirajte novi odmor za svoje zaposlene',

    replacedby: 'Zamenjeno sa',
    vacationname: 'Naziv odmora',
    totaldays: 'Ukupno dana',
    foryear: 'Za godinu',
    accumulatemonthly: 'Akumuliraj mesečno',
    halfdays: 'Poludani',
    onetimetake: 'Jednokratno korišćenje',
    extradays: 'Dodatni dani',
    year: 'Svake godine',
    day: 'Svaki dan',
    righttousemonth: 'Pravo na korišćenje meseca',
    righttouseyear: 'Pravo na korišćenje godine',
    howcanuse: 'Kako možete koristiti ovaj odmor',
    hide: 'Sakrij',
    roles: 'Uloge',

    addvacation: 'Dodaj odmor',
    nogeneralvacations: 'Nema dodanih opštih odmora',

    days: 'Dani',
    righttousenextyear: 'Može se koristiti sledeće godine',

    manageempvacations: 'Upravljanje odmora zaposlenih',
    onvacation: 'Na odmoru',
    pendingdepartmentleadapproval: 'Na čekanju odobrenja vođe odeljenja',
    pendinghrapproval: 'Na čekanju odobrenja HR-a',
    approved: 'Odobreno',
    rejected: 'Odbijeno',
    requestdays: 'Zatraži dane',
    requestedhalfdays: 'Zatraženi poludani',
    requestedhalfdaysam: 'AM',
    requestedhalfdayspm: 'PM',
    vacationtype: 'Tip odmora',
    reason: 'Razlog',
    decision: 'Odluka',
    approvebtn: 'Odobri',
    rejectbtn: 'Odbij',
    nopendingdepartmentleadvacations:
      'Nema odmora na čekanju odobrenja vođe odeljenja',
    norejectedvacations: 'Nema odbijenih odmora',
    nopendinghrapprovalvacations: 'Nema odmora na čekanju odobrenja HR-a',
    noapprovedvacations: 'Nema odobrenih odmora',

    info: 'Informacije',

    rejectnotifycandidate: 'Obavesti kandidata o odbijanju',

    basevacation: 'Osnovna definicija',
    basevacationdc:
      'Uređujete odmor specifično za jednog zaposlenog, ovaj odmor se zasniva na:',

    ispaid: 'Da li je plaćen',
    ispaidontermination: 'Plaća se po prestanku ugovora',
    dailypaypercentage: 'Procenat dnevne plate'
  },

  alerts_vacations_module: {
    dateunique: 'Ovaj datum već postoji kao državni praznik',
    added: 'Uspešno dodat novi državni praznik',
    deleted: 'Uspešno obrisan državni praznik',
    updated: 'Uspešno ažuriran državni praznik',

    smthwrong: 'Nešto je pošlo naopako, molimo pokušajte ponovo',

    addedvac: 'Uspešno dodat novi opšti odmor',
    updvacation: 'Uspešno ažuriran opšti odmor',
    delvacation: 'Uspešno obrisan opšti odmor',

    approvedvacation: 'Zahtev za odmor je uspešno odobren',
    rejectedvacation: 'Zahtev za odmor je uspešno odbijen',
    rejectreason: 'Molimo prvo unesite razlog odbijanja',
    deletedvacation: 'Zahtev za odmor je uspešno obrisan'
  },

  payment_settings: {
    paymentsettings: 'Podešavanja Plaćanja',
    packages: 'Paketi',
    availablemodules: 'Dostupni Moduli',
    activemodules: 'Aktivni Moduli',
    invoices: 'Fakture',
    activemodulesdsc: 'Lista modula koje trenutno koristite',
    noactivemodules: 'Nema aktivnih modula za vašu kompaniju',
    'euro-peremployee': '€ / po zaposlenom',
    availablemodulesdsc: 'Lista modula koji su dostupni i možete ih koristiti',
    addmodule: 'Dodaj Modul',
    allmodulesasigned:
      'Svi Hrbee moduli su aktivirani za vašu kompaniju / instituciju',

    invoiceno: 'Broj fakture',
    paymentmethod: 'Metod Plaćanja',
    amount: 'Iznos za plaćanje',
    details: 'Detalji',
    noinvoice: 'Nemate nijednu fakturu još'
  },

  'payment_settings-alerts': {
    packagerequestsent: 'Zahtev za paket je poslat'
  },

  account_settings: {
    rate_by: 'Sekcija treba da bude ocenjena od strane',
    rate_frequency: 'Učestalost ocenjivanja',
    staff_category: 'Kategorija osoblja',
    pay_tax: 'Plaćanje poreza',
    pay_tax_short: 'Porezi',
    pay_contribution: 'Plaćanje doprinosa',
    pay_contribution_short: 'Doprinosi',
    job_description: 'Opis posla',
    belongstodepartment: 'Pripada odeljenju',
    belongstosubdepartment: 'Pripada pododeljenju',

    api: 'API',
    apidsc: 'Generišite svoj API ključ i koristite neke od endpoint-a',
    apigeneratebutton: 'Generiši API ključ',
    apiGetEmployees:
      'Koristite ovu URL adresu da dobijete listu svojih zaposlenih',
    apiGetVacations: 'Koristite ovu URL adresu da dobijete listu odmora',
    apiGetPerformances:
      'Koristite ovu URL adresu da dobijete listu performansi',

    accountsettings: 'Podešavanja naloga',
    businessinfo: 'Informacije o biznisu',
    businessinfodsc:
      'Promenite osnovne informacije o svojoj kompaniji u nastavku',
    mainpayrollcurrency: 'Glavna valuta za obračun plata',
    selectmainpayrollcurrency: 'Izaberite valutu kompanije',
    mainpayrollcurrencyhelp:
      'Ova valuta se koristi kao osnova za obračun plata i izveštavanje.',
    mainpayrollcurrencyrequired: 'Glavna valuta za obračun plata je obavezna.',
    businesslogo: 'Logo biznisa',
    businesslogodsc: 'Ovde možete da otpremite svoj biznis logo',
    businesspassword: 'Lozinka za biznis',
    businessdresscode: 'Kodeks oblačenja biznisa',
    businessregulation: 'Regulativa biznisa',
    businessorganogram: 'Organogram biznisa',
    generalsettings: 'Opšta podešavanja',
    integrations: 'Integracije',
    integrationsaccesscontrol: 'Integracija kontrole pristupa',
    integrationsaccesscontroldc:
      'Povežite svoj API da pratite vreme dolaska/odlaska svojih zaposlenih',
    integrationsaccesscontroldocumentation: 'Pogledajte API dokumentaciju',
    integrationsauthtype: 'Tip autentifikacije',
    integrationsauthendpoint: 'Endpoint autentifikacije',
    integrationsauthusername: 'Korisničko ime autentifikacije',
    integrationsauthpassword: 'Lozinka autentifikacije',
    integrationsauthtoken: 'Token autentifikacije',
    integrationsapiendpoint: 'API endpoint',
    localedc:
      'Ova postavka će odrediti na kojem jeziku će se slati emailovi vašim zaposlenima',
    employeeaccesses: 'Pristupi zaposlenih',
    attachcertificate: 'Priloži sertifikat',
    editattachcertificate: 'Uredi sertifikat',
    seecertificate: 'Pogledaj sertifikat',
    save: 'Sačuvaj',
    attachbusinesscertificate: 'Priloži poslovni sertifikat',
    addbusinessregulation: 'Dodaj poslovnu regulativu',
    addbusinessregulationinfo: 'Otpremite svoje poslovne regulative',

    profilelogo: 'Logo profila',
    businesscategorylogo: 'Logo kategorije biznisa',
    changelogo: 'Promeni logo',
    uploadlogo: 'Otpremi logo',

    fileaccepted: 'Datoteka je prihvaćena: ',
    maxfile: 'Maks. veličina datoteke: ',

    changepassword: 'Promeni lozinku',
    changepassworddsc:
      'Ako trebate da promenite lozinku svog naloga, možete to uraditi ovde',
    currentpassword: 'Trenutna lozinka',

    createdepartment: 'Kreiraj odeljenje',
    createposition: 'Kreiraj poziciju',

    departmentname: 'Ime odeljenja',
    departmentclass: 'Klasa odeljenja',
    reportto: 'Izveštaj za',
    adddepartment: 'Dodaj odeljenje',

    positionname: 'Ime pozicije',
    choosedepartment: 'Izaberi odeljenje',
    choosesubdepartment: 'Izaberi pododeljenje',
    addposition: 'Dodaj poziciju',
    addsubdepartment: 'Dodaj pododeljenje',
    addsubsubdepartment: 'Dodaj podpododeljenje',

    edit: 'Uredi',
    delete: 'Obriši',

    noposition: 'Nema kreiranih pozicija u ovom odeljenju',

    updatedepartment: 'Ažuriraj odeljenje',
    updateposition: 'Ažuriraj poziciju',

    uploaddresscode: 'Otpremi kod oblačenja biznisa',
    adddresscode: 'Dodaj novi kodeks oblačenja',
    back: 'Nazad',
    nodresscode: 'Nema kodeksa oblačenja',
    nodresscodedsc:
      'Idite da dodate novi kodeks oblačenja i kreirate kodeks oblačenja za svoju kompaniju',

    employeestatistics: 'Statistika zaposlenih',

    employeereports: 'Izveštaji o zaposlenima',
    employeereportsdc:
      'Generišite Excel datoteku koja sadrži sve podatke o zaposlenima u kompaniji',

    expiredcontract: 'Zaposleni sa isteklim ugovorom',
    employeecontracts30: 'Ugovori zaposlenih koji ističu u narednih 30 dana',
    employeecontracts60: 'Ugovori zaposlenih koji ističu u narednih 60 dana',
    employeecontracts_intern_7: 'Ugovori o praksi koji ističu za 7 dana',
    employeecontracts_intern_15: 'Ugovori o praksi koji ističu za 15 dana',
    employeecontracts_all_normal: 'Svi normalni ugovori',
    employeecontracts_all_interns: 'Svi ugovori o praksi',
    employeecontracts_probation_7: 'Ugovori na probaciji koji ističu za 7 dana',
    employeecontracts_probation_16:
      'Ugovori na probaciji koji ističu za 16 dana',
    employeecontracts_all: 'Svi ugovori zaposlenih',
    nodatafound: 'Nema pronađenih podataka',

    employeeleavereports: 'Izveštaji o odsustvima zaposlenih',
    employeeleavereportsdc:
      'Generišite Excel datoteku koja sadrži sve podatke o odsustvima zaposlenih u kompaniji',

    employeepromotionsreports: 'Izveštaji o promocijama zaposlenih',
    employeepromotionsreportsdc:
      'Generišite Excel datoteku koja sadrži sve podatke o promocijama zaposlenih u kompaniji',

    recruitmentreports: 'Izveštaji o regrutaciji',
    recruitmentreportsdc:
      'Generišite Excel datoteku koja sadrži statistike regrutacije',

    downloadreport: 'Preuzmi izveštaj',
    downloadreportall: 'Preuzmi sveobuhvatan izveštaj',
    downloadleavesreport: 'Preuzmi izveštaj o odsustvima',
    downloadunusedleavesreport: 'Preuzmi izveštaj o neiskorišćenim odsustvima',

    noexpiringcontracts: 'Nema ugovora koji ističu u narednih 60 dana',

    email_for_wages:
      'Da li želite da vaši zaposleni primaju email kada se generišu plate?',
    email_for_wages_info:
      'Ova postavka će odrediti da li će vaši zaposleni primati emailove kada se plate generišu',
    language_employee_emails: 'Izaberite jezik za email-ove zaposlenih',
    email_for_birthdays:
      'Da li želite da vaši zaposleni primaju emailove za rođendane?',
    email_for_birthday_info:
      'Ova postavka će odrediti da li će vaši zaposleni primati emailove za rođendane. Email će biti poslat od strane HrBee u ime vaše kompanije',
    email_for_work_anniversary:
      'Da li želite da vaši zaposleni primaju emailove za godišnjice zaposlenja?',
    email_for_work_anniversary_info:
      'Ova postavka će odrediti da li će vaši zaposleni primati emailove za godišnjice zaposlenja. Email će biti poslat od strane HrBee u ime vaše kompanije',
    anniversary_email_content: 'Sadržaj email-a za godišnjicu zaposlenja',
    vacation_weekend_count: 'Dozvoli vikend odmore',
    vacation_weekend_count_info: 'Ova postavka će odrediti postavke odmora',
    contracts_notification_and_read:
      'Dozvoli zaposlenima da označe pravila kao pročitana',
    contracts_notification_and_read_info:
      'Ova postavka će odrediti da li želite da omogućite zaposlenima da označe pravila kao pročitana'
  },

  'account_settings-alerts': {
    attachedfile: 'Poslovni sertifikat je uspešno priložen',
    somethingwentwrong: 'Došlo je do greške, molimo pokušajte ponovo',
    companyinfoupdated: 'Informacije o kompaniji su uspešno ažurirane',
    fillrequiredfields: 'Molimo popunite sva obavezna polja',

    maxfileerror:
      'Maksimalna veličina datoteke je 5 MB, molimo izaberite drugu datoteku',
    logosaved: 'Logo je uspešno otpremljen',
    noimage: 'Nema izabrane slike, molimo izaberite sliku',
    passwordchanged: 'Lozinka vašeg naloga je uspešno promenjena',
    regulationupdated: 'Poslovna regulativa je uspešno ažurirana',
    regulationsaved: 'Poslovna regulativa je uspešno sačuvana',
    dresscodesaved: 'Novi poslovni kodeks oblačenja je uspešno dodat',
    departmentsuccess: 'Odeljenje je uspešno dodato',
    subdepartmentsuccess: 'Pododeljenje je uspešno dodato',
    subsubdepartmentsuccess: 'Podpododeljenje je uspešno dodato',
    positionsuccess: 'Pozicija je uspešno dodata',

    departmentupdated: 'Odeljenje je uspešno ažurirano',
    subdepartmentupdated: 'Pododeljenje je uspešno ažurirano',
    positionupdated: 'Pozicija je uspešno ažurirana',
    trytodelete: 'Odeljenja sa radnim pozicijama ne mogu biti obrisana',
    deletedepartment: 'Odeljenje je uspešno obrisano',
    deleteposition: 'Pozicija je uspešno obrisana',
    deletedresscode: 'Kodeks oblačenja je uspešno obrisan'
  },

  feeds_module: {
    nodresscode: 'Nema kodeksa oblačenja',
    cancelfilters: 'Otkaži',
    comingsoon: 'Uskoro',

    birthdaymonth: 'Mesec rođenja',
    choosebirthday: 'Izaberite rođendan',
    noemployeebasedonthisfilter: 'Nema zaposlenih prema ovom filteru',
    chooseposition: 'Izaberite poziciju',
    email: 'E-pošta',
    mobile: 'Mobilni',

    createevent: 'Kreiraj događaj',
    createeventdsc: 'Kreirajte događaj koji će biti prikazan vašim zaposlenima',
    date: 'Datum',
    location: 'Lokacija',
    invited: 'Pozvani',
    note: 'Napomena',
    postevent: 'Objavi događaj',
    editevent: 'Izmeni događaj',
    updateevent: 'Ažuriraj događaj',
    cancel: 'Otkaži',
    edit: 'Izmeni',
    delete: 'Obriši',
    noevents: 'Nema događaja',

    share: 'Podeli',
    addlink: 'Dodaj link',
    image: 'Slika',
    paragraph: 'Paragraf',
    deletepost: 'Obriši objavu',
    nofeeds: 'Nema objavljenih feedova još',

    organogramofcompany: 'Organogram kompanije',
    dresscode: 'Kodeks oblačenja',
    regulations: 'Regulativa',
    contacts: 'Kontakti',
    events: 'Događaji',
    birthdays: 'Rođendani',
    chat: 'Čat',

    hrdepartment: 'Ljudski resursi ovog odeljenja',
    hrdepartmentdsc: 'Priprema vaše liste zaposlenih kroz odabrano odeljenje',
    noemployeeinthisdepartment: 'Nema zaposlenih u ovom odeljenju',

    feedpermissions: 'Dozvole za objavljivanje',
    editfeedpermissions: 'Ko može da objavljuje na feedu?',
    editfeedpermissionsbtn: 'Izmeni dozvole za objavljivanje',

    sharedwithdepartments: 'Podeljeno sa odeljenjima'
  },

  'feeds_module-alerts': {
    somethingwentwrong: 'Nešto je pošlo naopako, molimo pokušajte ponovo',
    deleteevent: 'Događaj je uspešno obrisan',
    updateevent: 'Događaj je uspešno ažuriran',
    requiredfields: 'Molimo popunite sva obavezna polja',
    addevent: 'Događaj je uspešno dodat',

    typesomething: 'Molimo prvo unesite nešto',
    addpost: 'Objava je uspešno dodat',
    deletepost: 'Objava je uspešno obrisana'
  },

  monthsvalue: {
    1: 'Januar',
    2: 'Februar',
    3: 'Mart',
    4: 'April',
    5: 'Maj',
    6: 'Jun',
    7: 'Jul',
    8: 'Avgust',
    9: 'Septembar',
    10: 'Oktobar',
    11: 'Novembar',
    12: 'Decembar'
  },

  insurance_module: {
    employees_insurances: 'Osiguranje zaposlenih',
    employees_insurances_description:
      'Ispod možete pronaći sve svoje zaposlene, možete izabrati jednog od njih i upravljati podacima o osiguranju',
    noemployeefound:
      'Nema pronađenih zaposlenih, molimo idite u modul zaposlenih i dodajte svoje zaposlene',
    for_employee: 'Za zaposlenog',
    insurances_for_employee_not_found: 'Nema podataka',
    full_name: 'Puno ime',
    total_insurance: 'Ukupno osiguranje',
    company_insurance: 'Plaćanje od strane kompanije',
    employee_insurance: 'Plaćanje od zaposlenog',
    relation: 'Veza',
    for_employee_ralations: 'Za veze zaposlenih',
    insurances_for_employee_relations_not_found: 'Nema podataka'
  },

  wages_module: {
    deletegeneratedwages: 'Izbrišite generisane plate',
    grosssalaryByHours: 'Bruto plata po satima',
    export_language: 'Izaberi jezik',
    description: 'Opis',
    primaryjob: 'Primarni posao',
    secondaryjob: 'Sekundarni posao',
    joindate: 'Datum pridruživanja',
    settingsfinances: 'Podešavanja plata za vašu kompaniju',
    'tax0-80': 'Porez 0-250',
    'tax80-250': 'Porez 0-250',
    'tax250-450': 'Porez 250-450',
    'tax>450': 'Porez > 450',
    contribution: 'Doprinos',
    overtime: 'Prekovremeni rad',
    wardship: 'Starateljstvo',
    weekendholidays: 'Vikend odmori',
    savefinancialsettings: 'Sačuvaj podešavanja plata',

    addemptowageslist: 'Dodaj novog zaposlenog na listu plata',
    back: 'Nazad',
    empwageslist: 'Lista plata zaposlenih',
    empwageslistdsc:
      'Ispod možete pronaći listu zaposlenih koji su dodati na listu plata',
    edit: 'Izmeni',
    delete: 'Obriši',
    noempinwageslist:
      'Nema zaposlenih na listi plata, molimo dodajte nove sada',

    generatewages: 'Generiši plate',
    taxdeclaration: 'Porezno prijavljivanje',
    export: 'Izvezi',
    salaryfor: 'Plate za',
    bonusfor: 'Bonusi za',
    grosssalary: 'Bruto plata',
    totalsalary: 'Ukupna plata',
    healthinsurancecost: 'Bruto osiguranje',
    healthinsurancecostneto: 'Neto osiguranje',
    rankofjob: 'Rang posla',
    absencededuction: 'Odbitak zbog odsustva',
    leavededuction: 'Odbitak zbog godišnjeg odmora',
    totaltax: 'Ukupan porez',
    netsalary: 'NET plata',
    nowagesgenerated: 'Nema generisanih plata',
    nobonuses: 'Nema bonusa',
    generatemonthly: 'Generiši mesečne plate zaposlenih',
    selectyear: 'Izaberi godinu',
    selectmonth: 'Izaberi mesec',
    editwages: 'Izmeni platu izabranog zaposlenog',
    editbonusof: 'Izmeni bonus za',
    advancepayment: 'Avansna isplata',
    leavewithoutpayment: 'Odsustvo bez isplate',
    bonuspayment: 'Isplata bonusa',
    mealspayment: 'Isplata obroka',
    workinghours: 'Radni sati',
    workhourspermonth: 'Radni sati po mesecu',
    priceperhour: 'Cena po satu',
    grosssalarybyhours: 'Bruto plata po satima',
    'overtime-nightshift': 'Prekovremeni rad - noćna smena',
    save: 'Sačuvaj',

    filter: 'Filter',
    clearfilter: 'Obriši filter',
    filterwages: 'Filter plata po godini i mesecu',
    closeallwages: 'Zatvori plate',
    no_salaries_available_for_period: 'Nema plata za {month} u {year}. godini',

    salarybonus: 'Bonus za platu',
    grosssalarybonus: 'Bruto bonus za platu',
    grosssalarytotal: 'Ukupna bruto plata',
    bonusnote: 'Napomena o bonusu',
    salaryincrements: 'Povećanja plata',
    incrementsalaryeverynyears: 'Povećaj platu svake',
    basesalary: 'Osnovna bruto plata',
    incrementsalarybyamount: 'Povećaj po iznosu',
    salaryincrementedbyvalue: 'Trenutna vrednost povećanja',
    years: 'godina(e)',
    onmonth: 'U mesecu',

    extra: 'Dodatno',

    closed: 'Zatvoreno',

    uploadbonuses: 'Otpremi bonuse',
    deletebonuses: 'Obriši bonuse',

    selectbonusexcel: 'Izaberi Microsoft Excel datoteku za otpremanje'
  },

  'wages_module-alerts': {
    somethingwentwrong: 'Nešto nije u redu, molimo pokušajte ponovo',
    settingsupdated: 'Podešavanja plata uspešno ažurirana',
    deletefromwageslist: 'Zaposleni obrisan sa liste plata',

    wagedelete: 'Plata uspešno obrisana',
    wageupdated: 'Plata uspešno ažurirana',
    wagesgenerated: 'Plate uspešno generisane',
    alredygenerated: 'Plate su već generisane za ovaj mesec'
  },

  noaccesspages: {
    nopackage: 'Nemate pristup ovom paketu',
    nopackagedsc:
      'Da biste imali pristup ovoj stranici, VI ili kompanija kojoj pripadate treba da aktivira ovaj paket',
    viewpackages: 'Pogledajte pakete',

    noaccesstopage: 'Nemate pristup ovoj stranici',
    noaccesstopagedsc:
      'Da biste imali pristup ovoj stranici, potrebno je da aktivirate svoj nalog putem verifikacije e-pošte'
  },
  aboutus_page: {
    aboutus: 'O nama',
    aboutusdsc1:
      'Usmereni smo na pružanje usluga koje pomažu kompanijama da povećaju svoj profit upravljanjem performansama svojih zaposlenih.',
    aboutusdsc2:
      'Digitalizacija procesa upravljanja ljudskim resursima je veoma važna za postizanje uspeha i razvoj kompanija.',
    aboutusdsc3:
      'Zato će, putem platforme Hr bee Management, preduzetnici moći da upravljaju zaposlenima kroz nekoliko modula koje platforma nudi.',
    aboutusdsc4: 'Postoji više od 320 potpuno digitalizovanih procesa.',
    aboutusdsc5:
      'Poznavanjem kapaciteta ljudskih resursa koje preduzeća imaju, biće im lakše da upravljaju i planiraju potrebne resurse za postizanje ciljeva koje su sebi postavili.',
    aboutusdsc:
      'Radeći u kancelariji ljudskih resursa i videći da mu većinu vremena oduzimaju svakodnevni tehnički procesi... Stao je na trenutak i počeo da razmišlja! Da li bi trebalo da imam izbor? Šta ako sam kao pčela? Da, pčela koja, uprkos velikom broju radnika, sve radi najbolje. Tamo sam sve počeo kao studiju slučaja unutar Kosova da se dalje razvijam u regionu, a zatim prema Evropi. Da, izgradili smo digitalne pčele kako bismo pomogli svakom od vas da upravljate zaposlenima i imate vremena za važne strateške procese za svoju kompaniju. Budite digitalni.',

    ourteam: 'Naš tim',
    ourteamdsc1: 'Tim Hr bee Management sastoji se od sledećih oblasti:',
    ourteamdsc2:
      'Menadžment, Ljudski resursi, Pravo i Informacione tehnologije',
    ourteamdsc3: 'Sa prosečnim radnim iskustvom iznad',
    ourteamdsc4: '18+ godina',
    ourteamdsc:
      'Digitalizacija procesa za upravljanje ljudskim resursima je veoma važna za postizanje uspeha i razvoj preduzeća. Zbog toga će, putem platforme Hr bee, preduzetnici moći da upravljaju zaposlenima kroz nekoliko modula koje platforma nudi. Poznavanjem kapaciteta ljudskih resursa koje preduzeća imaju, biće im lakše da upravljaju i planiraju potrebne resurse za postizanje ciljeva koje su sebi postavili.',

    ourpartners: 'Naši partneri',
    ourpartnersdsc: 'Neki od naših partnera u različitim zemljama posluju...',

    ourclients: 'Naši klijenti',
    ourclientsdsc: 'Neki od naših klijenata koji koriste Hrbee',

    weoperatein: 'Poslujemo u!',
    weoperateindsc1: 'Trenutno poslujemo u Kosovu i Albaniji',
    weoperateindsc2: 'Takođe radimo na lansiranju platforme u Evropi',
    weoperateindsc3: 'Ako želite da postanete naš partner za vašu zemlju',
    clickhere: 'kliknite ovde',

    contactus: 'Kontaktirajte nas',
    contactusdsc1:
      'Slobodno nas kontaktirajte za bilo kakva pitanja ili nedoumice koje imate.',
    contactusdsc2:
      'Uvek smo radosni da razgovaramo s vama. Pošaljite nam poruku',

    sendmsgbtn: 'Pošaljite poruku',

    address: 'Adresa',
    mainoffice: 'Adresa naše glavne kancelarije',
    information: 'Informacije',
    support: 'Podrška',
    franchizes: 'Franšize'
  },

  product_page: {
    featuresbtn: 'Karakteristike',
    createaccountbtn: 'Kreiraj nalog',
    backbtn: 'Nazad',

    company: 'Kompanije',
    companydsc:
      'Digitalizacija procesa upravljanja ljudskim resursima je veoma važna za postizanje uspeha i razvoj preduzeća. Kroz HR Bee platformu, kompanije će moći da upravljaju zaposlenima koristeći module koje platforma nudi.',
    companydsc1:
      'Prepoznavanjem ljudskih resursa koje preduzeća imaju, biće im lakše da upravljaju i planiraju potrebne resurse za postizanje ciljeva koje su postavili.',

    jobseeker: 'Tražioci posla',
    jobseekerdsc1:
      'Danas je pronalaženje posla veoma teško i ponekad izgleda gotovo nemoguće.',
    jobseekerdsc2:
      'Digitalizacija danas je veoma važan alat za pronalaženje posla.',
    jobseekerdsc3:
      'Zato, digitalizacijom profila tražioca posla, prvo kreirate standard za svoj profil, što je važno za dalji proces prijave za posao. Potrebno je da unesete svoje podatke samo jednom u sistem i zatim se prijavite za različite poslove jednim klikom.',

    signupandcreatecv: 'Registrujte se i kreirajte svoj CV',
    signupandcreatecvdsc1:
      'Da biste se prijavili za poslove, potrebno je da imate nalog tražioca posla sa HRBEE.',
    signupandcreatecvdsc2:
      'Čim se registrujete, imaćete mogućnost da kreirate svoj online CV, kao i da ga preuzmete u šablonu koji smo pripremili.',

    findjobandapply: 'Pronađite posao i prijavite se',
    findjobandapplydsc1: 'HR Bee olakšava proces traženja posla za tražioce.',
    findjobandapplydsc2:
      'Omogućava im da se prijave za oglase jednim klikom ili da sačuvaju posao za kasniju prijavu.',

    wekeepupdated: 'Obaveštavamo vas o vašoj prijavi',
    wekeepupdateddsc1:
      'HRBEE omogućava tražiocu posla da komunicira sa kompanijama za poziciju za koju se prijavio.',
    wekeepupdateddsc2:
      'To uključuje obaveštenja o vašoj prijavi. Primaćete notifikacije da ste pozvani na intervju, obaveštenja čak i kada je vaša prijava odbijena i ako se kvalifikujete da postanete zaposleni u toj kompaniji, imaćete svoj nalog kao zaposleni.',

    feedmodule: 'Modul Feeds',
    feedmoduledsc:
      'Modul feeds olakšava komunikaciju unutar kompanije između vas i vaših zaposlenih u realnom vremenu.',
    feedmodule1: 'INTERAGUJTE SA ZAPOSLENIMA',
    feedmodule2: 'Interagujte sa svojim zaposlenima unutar kompanije',
    feedmodule3:
      'Komunikacija i interakcija između zaposlenih unutar kompanije su od posebnog značaja. Kroz ovaj modul možete deliti važne informacije sa svojim zaposlenima, uz očuvanje poverljivosti tih informacija.',

    recruitmentmodule: 'Modul za zapošljavanje',
    recruitmentmoduledsc:
      'Modul za zapošljavanje olakšava proces zapošljavanja i pomaže vam da izvršite selekciju osoblja prema odabranim kriterijumima. Kroz ovaj modul, proces zapošljavanja će biti lakši, efikasniji i 100% brži nego pre.',
    recruitmentmodule1: 'KREIRANJE KONKURSA',
    recruitmentmodule2:
      'Kreirajte i upravljajte prijavama za slobodna radna mesta u vašoj kompaniji',
    recruitmentmodule3:
      'Kroz modul za zapošljavanje, proces kreiranja/objavljivanja konkursa i njegovog upravljanja biće mnogo jednostavniji. Potrebno je samo da popunite potrebna standardizovana polja i vaš oglas će biti objavljen. Takođe postoji šablon za opis vašeg konkursa.',
    recruitmentmodule4: 'INTERVJU',
    recruitmentmodule5: 'Izaberite i pozovite kandidate na intervju',
    recruitmentmodule6:
      'Odabir kandidata za intervju će biti mnogo lakši i jednostavniji. Nakon ocene CV-a kandidata, možete poslati poziv za intervju, potrebno je samo da navedete: dan, vreme intervjua i kandidat će automatski primiti obaveštenje o intervjuu od vas.',
    recruitmentmodule7: 'OCENE',
    recruitmentmodule8: 'Ocenjivanje kandidata na osnovu kriterijuma pozicije',
    recruitmentmodule9:
      'Ocenjivanje kandidata tokom intervjua je takođe veoma važan element i pomoći će vam na kraju procesa da jasnije i lakše izaberete najuspešnijeg kandidata za taj posao.',

    employeesmodule: 'Modul za zaposlene',
    employeesmoduledsc:
      'Preduzeće ne može da se razvija bez adekvatnog upravljanja ljudskim resursima. Upravljanje ljudskim resursima uključuje mnoge procese koje smo uključili u ovaj modul.',
    employeesmodule1: 'ZAPOSLENI',
    employeesmodule2: 'Upravljajte zaposlenima',
    employeesmodule3:
      'Upravljajte svim procesima ljudskih resursa digitalno i interaktivno sa zaposlenima u kompaniji.',
    employeesmodule4: 'DOKUMENTI',
    employeesmodule5: 'Upravljajte dokumentima svakog zaposlenog',
    employeesmodule6:
      'Svi dokumenti/datoteke zaposlenih biće digitalno arhivirani za svaku pojedinačnu osobu.',
    employeesmodule7: 'RADNI DETALJI',
    employeesmodule8: 'Upravljajte radnom istorijom zaposlenih',
    employeesmodule9:
      'Istorija razvoja bilo kog zaposlenog će biti pohranjena digitalno i dostupna obema stranama.',
    employeesmodule10: 'ZAPOŠLJAVANJE ZAPOSLENIH',
    employeesmodule11: 'Registracija zaposlenih',
    employeesmodule12:
      'Registracija zaposlenih može se obaviti kroz modul za zapošljavanje ili ručno unosom zaposlenog u kompaniju.',

    workingschedule: 'Modul radnog rasporeda',
    workingscheduledsc:
      'Upravljanje rasporedima i postavljanje osoblja na pravo mesto i vreme je od velike važnosti za razvoj procesa unutar kompanije.',
    workingschedule1: 'POSTAVKE RADNOG RASPOREDA',
    workingschedule2: 'Kreiranje rasporeda i smena za zaposlene.',
    workingschedule3:
      'Upravljanje i planiranje radnih sati za zaposlene je posebno važno za svakodnevne procese unutar kompanije.',
    workingschedule4: 'RADNI RASPORED',
    workingschedule5: 'Upravljanje radnim rasporedom zaposlenih.',
    workingschedule6:
      'Radno vreme može se upravljati po odeljenjima ili po zaposlenima unutar odeljenja.',

    vacationmodule: 'Modul odmora',
    vacationmoduledsc:
      'Modul odmora vam pomaže da upravljate i uskladite godišnje odmore vašeg osoblja sa aktivnostima vaše kompanije.',
    vacationmodule1: 'POSTAVKE ODMORA',
    vacationmodule2: 'Kreirajte i upravljajte vrstama odmora.',
    vacationmodule3:
      'Definišite vrste i dane odmora prema specifikacijama kompanije.',
    vacationmodule4: 'POSTAVKE ODMORA',
    vacationmodule5: 'Definišite državne praznike.',
    vacationmodule6:
      'Definišite zvanične praznike po zemljama i verskim uverenjima.',
    vacationmodule7: 'ZAHTEVI ZA ODMOR',
    vacationmodule8: 'Upravljanje zahtevima za odmor.',
    vacationmodule9:
      'Možete upravljati zahtevima za odmor vaših zaposlenih prema prioritetima koje imaju.',
    vacationmodule10: 'DOZVOLE ZA ODMOR',
    vacationmodule11: 'Proverite listu odobrenih/odbijenih odmora.',
    vacationmodule12:
      'Možete videti dane odmora za svakog zaposlenog prema vrstama odmora.',

    wagesmodule: 'Modul plata',
    wagesmoduledsc:
      'Ovaj modul vam olakšava obračun i generisanje svih isplata za vaše zaposlene.',
    wagesmodule1: 'POSTAVKE PLATA',
    wagesmodule2: 'Generisanje i ažuriranje plata zaposlenih.',
    wagesmodule3: 'Generisanje liste plata i uređivanje za izvršenje isplate.',
    wagesmodule4: 'POSTAVKE PLATA',
    wagesmodule5: 'Pregled profila generisanih plata zaposlenih.',
    wagesmodule6:
      'Generišite mesečne liste plata u profilima zaposlenih i omogućite zaposlenima da vide obračune svojih plata.',
    wagesmodule7: 'POSTAVKE PLATA',
    wagesmodule8: 'Obračun i generisanje plata se vrši u samo tri koraka.',
    wagesmodule9:
      'Morate da navedete godinu i mesec za koji želite da generišete, a svi obračuni se automatski vrše.',
    wagesmodule10: 'PLATE',
    wagesmodule11: 'Dodajte zaposlene u obračun plata.',
    wagesmodule12:
      'Dodavanje ili uklanjanje iz obračuna plata je veoma lako i jednostavno.',

    onboardmodule: 'Modul onboard',
    trainingmodule: 'Modul obuke',
    insurancemodule: 'Modul osiguranja',
    performancemodule: 'Modul performansi',
    underconstruction: '>>> U izradi - 35% završeno',

    createaccountasjobseeker: 'Kreirajte nalog kao tražilac posla',
    fillyourresume: 'Ispunite svoj CV',
    vacancyapply: 'Prijavite se za slobodne pozicije',
    acceptinvitationforinterview: 'Prihvatite poziv za intervju',

    features: 'Karakteristike'
  },
  auth_page: {
    jobseeker: 'TRAŽILAC POSLA',
    company: 'KOMPANIJA'
  },
  footer: {
    footerdescription:
      'Hr bee je softver za upravljanje ljudskim resursima zasnovan na oblaku. Pomažemo kompanijama da upravljaju svojim zaposlenima, a tražiocima posla da pronađu posao iz snova. Takođe mogu: tražiti, pronaći i sklopiti ugovor jedni s drugima.',

    product: 'Proizvod',
    jobseeker: 'Tražilac posla',
    pricing: 'Cenovnik',
    knowledgebase: 'Baza znanja',
    downloadapp: 'Preuzmi aplikaciju',
    partnerprogram: 'Partnerski program',
    api: 'API',

    company: 'Kompanija',
    aboutus: 'O nama',
    clients: 'Klijenti',
    partners: 'Partneri',
    whereweare: 'Gde se nalazimo?',
    contactus: 'Kontaktirajte nas',
    support: 'Podrška',

    allrightreserved: 'Sva prava © 2020 HR bee Management',
    privacypolicy: 'Politika privatnosti',
    termsconditions: 'Uslovi i odredbe'
  },
  header_page: {
    editimage: 'Izmeni sliku',
    insertimage: 'Dodaj sliku',
    namesurname: 'Ime i prezime',
    title: 'Titula',
    birthday: 'Datum rođenja',
    country: 'Država',
    city: 'Grad',
    nationalID: 'Nacionalna lična karta',
    profileID: 'Profil ID',
    shortbio: 'Kratka biografija',
    socialmedia: 'Društvene mreže:',

    add: 'Dodaj',
    edit: 'Izmeni',
    addnow: 'Dodaj sada'
  },
  notifications_page: {
    no_notifications: 'Nemate novih obaveštenja',
    all_notifications: 'Sva obaveštenja',
    mark_all_as_read: 'Označi sve kao pročitano'
  },
  navigationlinks: {
    training: 'HR Akademija',
    downloadcv: 'Preuzmi CV',
    product: 'Proizvod',
    pricing: 'Cene',
    aboutus: 'O nama',
    demo: 'Demo',
    login: 'Prijavi se',
    logout: 'Odjavi se',
    editcv: 'Uredi CV profil',
    dashboard: 'Kontrolna tabla',
    language: 'Jezik',
    newfeeds: 'Vesti',
    vacations: 'Odmori',
    salaries: 'Plate',
    schedules: 'Radni raspored',
    events: 'Događaji',
    organogram: 'Organogram kompanije',
    dresscode: 'Kodeks oblačenja',
    regulation: 'Regulativa',
    vacationrequests: 'Zahtevi za odmor',

    findjobs: 'Pronađi poslove',
    profileCV: 'Vaš CV profil',
    appliedpositions: 'Prijavljene pozicije',
    ratingsbyinterviews: 'Ocene po intervjuima',

    notifications: 'Obaveštenja',
    nnotifications: 'Obaveštenja',

    savedjobs: 'Sačuvani poslovi',

    registerascompany: 'Registruj se kao kompanija',
    registerasjobseeker: 'Registruj se kao tražilac posla',
    forgetpw: 'Zaboravili ste lozinku',
    details: 'Detalji',

    settingaccount: 'Podešavanja naloga'
  },

  alerts: {
    are_you_sure: 'Da li ste sigurni?',
    are_you_sure_delete: 'Da li ste sigurni da želite da obrišete?',
    confirm: 'Potvrdi',
    successful_login: 'Uspešno ste se prijavili',
    invalid_credentials: 'Korisnički podaci su netačni.',
    successful_logout: 'Uspešno ste se odjavili',
    successful_register:
      'Uspešno ste se registrovali. Molimo vas da se sada prijavite.',
    successful_account_activation:
      'Vaš nalog je uspešno aktiviran. Molimo vas da se prijavite.',
    successful_account_reset_email:
      'Ako imate nalog kod nas, uskoro ćete primiti e-mail.',
    successful_data_loaded: 'Podaci su učitani.',
    successful_data_updated: 'Podaci su ažurirani.',
    successful_data_deleted: 'Podaci su obrisani.',
    successful_data_saved: 'Podaci su sačuvani.',
    only_images: 'Molimo izaberite sliku',
    image_too_big:
      'Vaša datoteka je prevelika! Molimo izaberite sliku manju od 2MB',
    candidate_rating_completed: 'Kandidat je ocenjen.',
    package_activation_request_has_been_sent:
      'Zahtev za aktivaciju modula je uspešno poslat.',
    successfully_applied_to_job: 'Vaša prijava je uspešno završena!',
    successfuly_password_changed: 'Lozinka je uspešno promenjena.',
    successfuly_employee_added_salary_list:
      'Zaposleni je uspešno dodat na listu plata.',
    monthly_salary_generated_succesffuly:
      'Mesečne plate su uspešno generisane.',
    monthly_salary_generated_succesffuly_for_user:
      'Mesečna plata je uspešno generisana za ovog zaposlenog.',
    work_schedule_has_been_updated: 'Radni raspored je ažuriran.',
    payment_billing_cycle_update: 'Kreditni ciklus plaćanja je ažuriran',
    module_has_been_removed: 'Modul je uklonjen iz računa kompanije.',
    module_price_has_been_updated:
      'Detalji modula su ažurirani za trenutnu kompaniju.',
    company_module_invoice_deleted_sucessfully: 'Faktura je uspešno obrisana',
    successfull_message_sent:
      'Hvala. Vaša poruka je uspešno poslata. Kontaktiraćemo vas što je pre moguće.',
    reset_password_sent:
      'Ako imate nalog kod nas, uskoro ćete primiti e-mail za resetovanje lozinke.',
    reset_password_completed:
      'Vaša lozinka je resetovana. Molimo nastavite da se prijavite.',
    accepted_interview: 'Intervju je uspešno prihvaćen.',
    rejected_interview: 'Intervju je uspešno odbijen',
    language_added: 'Novi jezik je sačuvan.',
    language_delete: 'Jezik je uspešno obrisan.',
    driving_licence_add: 'Vozačka dozvola je uspešno dodata',
    driving_licence_delete: 'Vozačka dozvola je uspešno obrisana',
    same_driving_licence_error: 'Već imate ovu vozačku dozvolu u svom CV-u',
    computerskill_added: 'Nova računarska veština je uspešno dodata',
    education_added: 'Vaše obrazovanje je uspešno dodato',
    education_delete: 'Obrazovanje je uspešno obrisano',
    education_updated: 'Obrazovanje je uspešno ažurirano',
    experience_added: 'Vaše iskustvo je uspešno dodato',
    experience_updated: 'Iskustvo je uspešno ažurirano',
    experience_delete: 'Iskustvo je uspešno obrisano',
    training_added: 'Vaša obuka/kurs je uspešno dodata',
    training_updated: 'Obuka/kurs je uspešno ažurirana',
    training_delete: 'Obuka/kurs je uspešno obrisana',
    update_jobseeker: 'Vaš profil je uspešno ažuriran',
    image_upload: 'Vaša slika je uspešno otpremljena',
    noimage: 'Nema izabrane slike',
    saved_job: 'Sačuvali ste ovaj posao kao omiljeni',
    unsave_job: 'Uklonili ste ovaj posao iz omiljenih',
    computerskill_delete: 'Računarska veština je uspešno obrisana',
    otherskill_added: 'Nova veština je uspešno dodata',
    otherskill_delete: 'Veština je uspešno obrisana',
    email_already_taken: 'Žao nam je, ova adresa e-pošte je već zauzeta.',
    same_skill_error: 'Već imate ovu veštinu u svom CV-u',
    same_language_error: 'Već imate ovaj jezik u svom CV-u',
    name_should_only_container_letters: 'Ime treba da sadrži samo slova.',
    reset_password_token_expired:
      'Već ste kliknuli na dugme za resetovanje lozinke u vašem e-mailu. Molimo pokušajte ponovo da resetujete svoju lozinku.',
    acceptedinterview: 'Intervju je uspešno prihvaćen',
    rejectinterview: 'Intervju je uspešno odbijen',
    smthwrong: 'Nešto nije u redu, molimo pokušajte ponovo',
    msgsuccess: 'Vaša poruka je poslata',
    sum_of_company_and_employee_with_total_insurance:
      'Zbir `Plaćanje od kompanije` i `Plaćanje od zaposlenog` treba da bude jednak `Ukupnom osiguranju`',
    total_insurance_more_than_0: 'Ukupno osiguranje treba da bude veće od 0'
  },

  inputs: {
    latitude: 'Geografska širina',
    longitude: 'Geografska dužina',
    radius_km: 'Poluprečnik km',
    title: 'Naslov',
    serial_number: 'Serijski broj',
    description: 'Opis',
    allow_emails_when_generating_wages:
      'Zaposleni će biti obavešteni ili će dobiti email kada kompanija generiše plate',
    select: 'Izaberi',
    comment: 'Dodaj komentar',
    rate_percentage: 'Procenat %',
    contact_number: 'Kontakt telefon',
    contact_person: 'Kontakt osoba',
    how_do_you_hear_for_us: 'Kako ste saznali za nas?',
    country: 'Zemlja',
    probation: 'Probacija',
    internship: 'Praksa?',
    maritalstatus: 'Bračni status',
    email: 'E-mail',
    password: 'Lozinka',
    confirm_password: 'Potvrdi lozinku',
    current_password: 'Trenutna lozinka',
    age: 'Godine',
    first_name: 'Ime',
    last_name: 'Prezime',
    national_id: 'Lični identifikacioni broj',
    business_name: 'Naziv firme',
    dateOfBirth_desc: 'Datum rođenja',
    birthday: 'Rođendan',
    phone_number: 'Broj telefona',
    select_category: 'Izaberi kategoriju',
    profession: 'Izaberi profesiju',
    business_number: 'Poslovni broj',
    business_fiscal_number: 'Fiskalni broj',
    numberofEmployee: 'Broj zaposlenih',
    select_country: 'Zemlja',
    select_city: 'Grad',
    probation_months: 'Period probacije - u mesecima',
    health_insurance_monthly_cost: 'Trošak zdravstvenog osiguranja - mesečno',
    job_title: 'Naziv posla',
    job_title_desc: 'JavaScript programer',
    company_name: 'Naziv kompanije',
    company_name_desc: 'Google',
    current_country: 'Trenutna zemlja',
    training_title: 'Naziv obuke',
    started_date: 'Datum početka',
    join_date: 'Datum pridruživanja',
    status: 'Status',
    statusjob: 'Status posla: ',
    salaryineuro: 'Plata u €',
    jobdsc: 'Opis radnog mesta',
    join_date_desc: 'Datum kada pozicija počinje',
    leave_date: 'Datum odlaska',
    finish_date: 'Datum završetka',
    leave_date_desc: 'Datum kada pozicija završava',
    still_work: 'Još uvek radim ovde',
    still_taking: 'Još uvek sam na ovoj obuci/tečaju',
    still_in_education: 'Još nisam diplomirao/diplomirala.',
    job_description: 'Opis posla',
    activities_description: 'Aktivnosti',
    select_skill: 'Izaberi veštinu',
    select_driving_licence: 'Izaberi vozačku dozvolu',
    select_language: 'Izaberi jezik',
    edit_image: 'Izmeni sliku',
    edit_profile_image: 'Izmeni profilnu sliku',
    short_biography: 'Kratka biografija',
    school_name: 'Naziv škole',
    school_name_desc: 'Naziv škole, univerziteta, fakulteta.',
    field_of_study: 'Oblast studija',
    field_of_study_desc: 'Medicinska sestra, ekonomija...',
    degree: 'Stepen',
    degree_desc:
      'Na primer: Srednja škola, Stručna diploma, Bachelor diploma, Master diploma',
    date_of_birth: 'Datum rođenja',
    social_links: 'Društveni linkovi',
    responsible_name_surname: 'Odgovorna osoba kompanije',
    new_password: 'Unesite novu lozinku',
    confirm_new_password: 'Potvrdite novu lozinku',
    nationality: 'Nacionalnost',
    address: 'Adresa',
    salaryType: 'Tip plate',
    job_tags: 'Tagovi',
    employmentType: 'Tip zaposlenja',
    department: 'Odeljenje',
    sharewithdepartments:
      'Podeli sa odeljenjima (ostavite prazno za deljenje sa svim)',
    position: 'Pozicija',
    start_date: 'Datum početka',
    start_date_desc: 'Datum kada ugovor počinje ili je počeo.',
    end_date: 'Datum završetka',
    end_date_desc: 'Datum kada je napustio ovu poziciju.',
    conditions: 'Uslovi',
    document_type: 'Tip dokumenta',
    document_title: 'Naslov dokumenta',
    document_description: 'Opis dokumenta',
    document_expire_date: 'Datum isteka dokumenta',
    expiry_notification_days: 'Dani obaveštenja pre isteka',
    public_holiday_date: 'Dodajte jedinstveni datum praznika',
    fiscal_number: 'Fiskalni broj',
    fullname: 'Puno ime',
    message: 'Poruka',
    message_desc: 'Molimo vas da napišete svoju poruku.',
    newpassword_confirm: 'Molimo vas da potvrdite novu lozinku.',
    gender: 'Pol',
    female: 'Ženski',
    male: 'Muški',
    company_ceo: 'CEO kompanije',
    companyname: 'Naziv kompanije',
    head_of_hr: 'Šef ljudskih resursa',
    certificate: 'Poslovna sertifikacija',
    select_member: 'Izaberi člana',
    relation: 'Odnos',
    total_insurance: 'Ukupno osiguranje',
    company_insurance: 'Plaćanje od strane kompanije',
    employee_insurance: 'Plaćanje od strane zaposlenog',
    locale: 'Izaberite jezik',
    qualification: 'Kvalifikacija',
    orientation: 'Orijentacija',
    notes: 'Napomene'
  },

  inputError: {
    targets_required: 'Polja ciljeva su obavezna',
    required_terms_conditions:
      'Molimo prihvatite uslove pre nego što nastavite.',
    account_type_required: 'Molimo izaberite tip naloga.',
    required: 'Ovo polje je obavezno.',
    national_id_required:
      'Lični identifikacioni broj je obavezan i treba da bude jedinstven. Molimo unesite validan broj.',
    check_email: 'Molimo proverite da li e-mail postoji ili je ispravno unet.',
    password: 'Ovo polje je obavezno i mora imati najmanje 6 karaktera.',
    old_password:
      'Molimo unesite staru lozinku. Minimum 6 karaktera je obavezno.',
    new_password:
      'Molimo unesite novu lozinku. Minimum 6 karaktera je obavezno.',
    confirm_password: 'Potvrda lozinke treba da bude ista kao lozinka.',
    confirm_new_password:
      'Potvrda nove lozinke treba da bude ista kao nova lozinka.',
    terms: 'Molimo prihvatite uslove i odredbe.',
    confirm_dialog_delete: 'Da li ste sigurni da želite da obrišete ovo?',
    alert_cannot_add_same_skill:
      'Ne možete dodati istu veštinu. Molimo dodajte neku drugu.',
    invalid_credentials: 'Kredencijali korisnika su netačni.',
    max_file_upload_size_exceeded:
      'Prekoračen je limit veličine datoteke od 5MB. Molimo otpremite manju datoteku.',
    upload_file_first: 'Molimo prvo otpremite datoteku',
    no_file_added: 'Nijedna datoteka nije dodata',
    old_password_invalid:
      'Stara lozinka je nevažeća. Molimo proverite pre nego što pokušate ponovo.',
    public_holiday_must_be_unique:
      'Molimo unesite drugi datum, datumi javnih praznika treba da budu jedinstveni.',
    already_generated_salary_in_this_month:
      'Već ste generisali platu za ovaj mesec.',
    already_generated_salary_in_this_month_for_this_user:
      'Ovaj zaposleni je već imao generisanu platu za izabrani mesec.',
    message_required: 'Molimo napišite vašu poruku.',
    fullname_required: 'Molimo napišite vaše puno ime.',
    phone_number_required: 'Molimo unesite vaš broj telefona.',
    email_address_unique_required:
      'E-mail adresa zaposlenog treba da bude jedinstvena. Molimo dodajte drugu e-mail adresu.',
    email_already_taken: 'Žao nam je, ova e-mail adresa je već zauzeta.',
    fill_all_required_fields: 'Molimo popunite sva obavezna polja.',
    payroll_not_supported_nmk:
      'Obračun plata još nije podržan za kompanije iz Severne Makedonije.',
    reset_password_token_expired:
      'Već ste kliknuli na dugme za resetovanje lozinke u vašem e-mailu. Molimo pokušajte ponovo da resetujete vašu lozinku.',
    vacation_dates_already_placed:
      'Već imate odmor zakazan za datume koje ste tražili. Molimo promenite datume.',
    oneIsRequired: 'Bar jedna opcija je obavezna'
  },

  btn: {
    complete: 'Završeno',
    update: 'Ažuriraj',
    connect: 'Poveži',
    disconnect: 'Prekini vezu',
    delete: 'Obriši',
    edit: 'Uredi',
    generatewarningletter: 'Generiši upozorenje',
    printbtn: 'Štampaj',
    generatecontract: 'Generiši ugovor',
    filtejobsbtn: 'Filtriraj poslove',
    cancelbtn: 'Otkaži',
    addbtn: 'Dodaj',
    viewbtn: 'Pogledaj',
    updatebtn: 'Ažuriraj',
    savebtn: 'Sačuvaj',
    detailsbtn: 'Detalji',
    backbtn: 'Nazad',
    applynowbtn: 'Prijavi se sada',
    applybtn: 'Prijavi se',
    rejectbtn: 'Odbij',
    acceptbtn: 'Prihvati',
    settingaccountbtn: 'Podešavanja naloga',
    logoutbtn: 'Odjavi se',
    changepwbtn: 'Promeni lozinku',
    unsave: 'Ukloni sačuvano',
    savedjobsbtn: 'Sačuvani poslovi',
    save: 'Sačuvaj'
  },

  find_jobs_page: {
    position: 'Pozicija',
    at: 'u',
    deadline: 'Rok',
    category: 'Kategorija',
    country: 'Zemlja',
    city: 'Grad',
    alredyapplied: 'Već ste se prijavili',
    motivationletter: 'Motivaciono pismo',
    recommendationletter: 'Preporučeno pismo',
    refferences: 'Reference',
    motivationletterinput:
      'Molimo vas da ovde napišete svoje motivaciono pismo',
    recommendationletterinput:
      'Molimo vas da ovde napišete svoje preporučeno pismo',
    refferencesletterinput: 'Molimo vas da ovde napišete svoje reference',
    searchplaceholder: 'Upišite naslov posla i pritisnite enter',
    sorrynojobs: 'Žao nam je, nema dostupnih poslova!',
    sorrynofavoritejobs: 'Nemate sačuvane omiljene poslove!'
  },

  find_jobs_page_filter: {
    filterjobstxt: 'Filtriraj poslove',
    filterjobstxt2: 'Pripremamo vašu listu poslova prema tim filtrima',
    filterbycountry: 'Filtriraj po zemlji',
    filterbycity: 'Filtriraj po gradu',
    filterbycategory: 'Filtriraj po kategoriji',
    filterbysavedjobs: 'Filtriraj po sačuvanim poslovima',
    selectcountry: 'Izaberite zemlju',
    selectcity: 'Izaberite grad',
    selectcategory: 'Izaberite kategoriju',
    applyfilterbtn: 'Primeni filter',
    filterbysalarytype: 'Filtriraj po vrsti plate',
    selectsalarytype: 'Izaberite vrstu plate',
    filterbyemptype: 'Filtriraj po vrsti zaposlenja',
    selectemptype: 'Izaberite vrstu zaposlenja',
    savedjobs: 'Sačuvani poslovi',

    searchbytitle: 'Pretraži po naslovu'
  },

  applied_positions_jobseeker_page: {
    position: 'Pozicija',
    category: 'Kategorija',
    country: 'Zemlja',
    city: 'Grad',
    applicationstatus: 'Status prijave',
    new_application: 'Nova prijava',
    rejected_candidate: 'Prijava odbijena',
    blacklist_candidate: 'Prijava odbijena',
    accepted_interview: 'Prihvaćen intervju',
    invited_to_interview: 'Pozvan na intervju',
    rejected_interview: 'Intervju odbijen',
    potential_candidate: 'Potencijalni kandidat',
    hired_candidate: 'Zaposlen kandidat',
    nojobapplicationtxt: 'Žao nam je, nemate nijednu prijavu za posao!',
    dscnewapplication: 'Nova prijava',
    dsctypeinterview: 'Tip intervjua',
    dscdescriptioninterview: 'Opis',
    dscdateandtimeinterview: 'Datum i vreme',
    dscdate: 'Datum',
    dsctime: 'Vreme',
    dscrejected: 'Prijava je odbijena.',
    dscrejectedinterview: 'Intervju je odbijen od strane vas ili kompanije.',
    dscpotentialcandidate: 'Dodati ste na listu potencijalnih kandidata.',
    dschiredcandidate:
      'Čestitamo. Ova kompanija vas je zaposlila za ovu poziciju. Oni će vas uskoro kontaktirati.'
  },

  jobseeker_ratings_page: {
    position: 'Pozicija',
    category: 'Kategorija',
    country: 'Zemlja',
    city: 'Grad',
    backbtn: 'Nazad',
    detailsbtn: 'Detalji',
    nojobapplicationnoratingstxt:
      'Žao nam je, nemate ocene ili prijave za posao!',
    averagerate: 'Prosečna ocena',
    none: 'Nema',
    rates: 'Ocene',
    rateEducation: 'Obrazovanje',
    rateExperience: 'Iskustvo',
    rateLanguage: 'Strani jezik',
    rateGeneralKnowledge: 'Opšte znanje',
    rateJudgement: 'Sposobnost prosudbe',
    rateKnowledgePosition: 'Znanje o poziciji',
    rateLogical: 'Logičko razmišljanje',
    rateITSkills: 'IT veštine',
    rateOtherSkills: 'Druge veštine'
  },

  setting_account_page: {
    settingaccounttxt: 'Podešavanje naloga',
    myaccounttxt: 'Moj nalog',
    notificationtxt: 'Obaveštenje',
    privacytxt: 'Privatnost',
    accountinformationtxt: 'Informacije o nalogu',
    mainaccountinfotxt: 'Glavni podaci o nalogu',
    changepwtxt: 'Promeni lozinku',
    changepwdsctxt:
      'Ako želite da promenite lozinku svog naloga, možete to učiniti ovde'
  },

  language_proficiency: {
    reading: 'Čitanje',
    understanding: 'Razumevanje',
    speaking: 'Govorenje',
    writing: 'Pisanje',
    ELEMENTARY: 'Osnovni',
    LIMITED_WORKING: 'Ograničeno radno',
    PROFESSIONAL_WORKING: 'Profesionalno radno',
    FULL_PROFESSIONAL: 'Puno profesionalno',
    NATIVE: 'Izvorni',
    proficiency: 'Sposobnost',
    Beginner: 'Početnik',
    Advanced: 'Napredni',
    Average: 'Srednji',
    Excellent: 'Izvrsno',
    Professional: 'Profesionalno'
  },

  your_profile_cv: {
    no_experience: 'Nema dodate radne iskustvo',
    show_file: 'Prikaži fajl',
    no_file: 'Nema uključenih fajlova',
    no_logo: 'Nema uključenog logotipa',
    present: 'Prisutno',
    actions: 'izmeni | obriši',
    edit: 'Izmeni',
    delete: 'Obriši',
    cancel: 'Otkaži',
    add_experience: 'Dodaj iskustvo',
    add_experience_1: 'Dodajte svoje radno iskustvo',
    position: 'Pozicija',
    check_uncheck: 'označi | poništi',
    add_document: 'Dodaj dokument',
    image_company: 'Dodaj logotip kompanije',
    alredy_have_image: 'Već imate logotip kompanije',
    edit_experience: 'Izmeni iskustvo',
    alredy_have_document:
      'Već imate dokument. Unesite novi ako želite da ga promenite',

    no_education: 'Nema dodate obrazovanje',
    school_name: 'Ime škole',
    field_study: 'Oblast studija',
    from_to: 'od - do',
    level_education: 'Nivo obrazovanja',
    city: 'Grad',
    country: 'Država',
    file: 'Fajl',
    add_education: 'Dodaj obrazovanje',
    add_education_1: 'Dodajte obrazovanje koje ste pratili',
    other_degree: 'Druga diploma',
    other_field_study: 'Druga oblast studija',
    edit_education: 'Izmeni obrazovanje',

    no_training: 'Nema dodate obuke',
    institution: 'Institucija',
    training_course: 'Obuka | Kurs',
    add_training: 'Dodaj obuku | kurs',
    add_training_1: 'Dodajte obuke koje ste pratili',
    edit_training: 'Izmeni obuku | kurs',

    no_language: 'Nema dodate jezike',
    language: 'Jezik',
    add_language: 'Dodaj jezik',
    add_language_1: 'Izaberite jezik koji znate',

    no_c_skill: 'Nema dodate računarske veštine',
    skill: 'Veština',
    level: 'Nivo',
    add_c_skill: 'Dodaj računarske veštine',
    add_c_skill_1: 'Dodajte veštine koje znate',
    select_skill: 'Izaberite veštinu',
    select_level: 'Izaberite nivo',

    no_o_skill: 'Nema dodate druge veštine',
    add_o_skill: 'Dodaj druge veštine',
    add_o_skill_1: 'Dodajte veštinu koju znate',

    no_driving: 'Nema dodatu vozačku dozvolu',
    add_driving: 'Dodaj vozačku dozvolu',
    add_driving_1: 'Dodajte vozačku dozvolu koju imate',
    category_license: 'Kategorija dozvole'
  },

  notifications: {
    requested_vacation: 'zatraženi odmor.',
    job_new_application: 'prijavio se za',
    admin_approved_package_request:
      'administrator je odobrio vašu molbu za aktivaciju paketa',
    invited_interview: 'vas je pozvao na intervju za',
    rejected_interview: 'odbacio vašu prijavu za',
    rated_profile: 'ocenio vaš CV na'
  },

  page_titles: {
    company_jobs: 'Poslovi u kompaniji',
    add_new_job: 'Dodaj novi posao',
    candidate_interviews: 'Intervjui sa kandidatima',
    rated_candidates: 'Ocenjeni kandidati',
    company_employees: 'Zaposleni u kompaniji',
    main_profile_data: 'Glavni podaci profila',
    employees_salary_list: 'Lista plata zaposlenih',
    assign_employee: 'Dodeli zaposlenog',
    generated_salaries: 'Generisane plate'
  },

  navigation: {
    search_jobs: 'Pretraži poslove',
    resume: 'Životopis',
    download_resume: 'Preuzmi životopis',
    applied_positions: 'Prijavljene pozicije',
    ratings: 'Ocene',
    account_settings: 'Podešavanja naloga',
    no_notification: 'Nemate novih obaveštenja.',
    all_notifications: 'Sva obaveštenja',
    mark_all_as_read: 'Označi sve kao pročitano',
    logout: 'Odjavi se',
    feeds: 'Vesti',
    recruitment: 'Regrutacija',
    jobs: 'Poslovi',
    interviews: 'Intervjui',
    blacklist: 'Crna lista',
    employees: 'Zaposleni',
    all_employees: 'Svi zaposleni',
    birthdays: 'Rođendani',
    performance_settings: 'Podešavanja učinka',
    work_schedule: 'Radna vremena',
    vacations: 'Odmori',
    vacation_requests: 'Zahtevi za odmor',
    public_holiday_settings: 'Podešavanja državnih praznika',
    general_vacation_settings: 'Opšta podešavanja odmora',
    finances: 'Finansije',
    employee_salaries: 'Plate zaposlenih',
    generate_salaries: 'Generiši plate',
    payment_settings: 'Podešavanja plaćanja',
    organogram: 'Organogram',
    regulations: 'Propisi',
    dress_code: 'Kodeks oblačenja',
    profile: 'Profil',
    work_details: 'Detalji o radu',
    performance: 'Učinak',
    documents: 'Dokumenti',
    salary: 'Plata'
  },

  button: {
    create_cv: 'Kreirajte svoj CV',
    are_you_a_company: 'Da li ste kompanija?',
    cancel: 'Otkaži',
    close: 'Zatvori',
    save: 'Sačuvaj',
    export: 'Izvezi',
    update: 'Ažuriraj',
    chooseImage: 'Izaberite sliku',
    removeImage: 'Ukloni sliku',
    rate: 'Oceni',
    reject: 'Odbaci',
    book_time_off: 'Zakaži slobodno vreme',
    send_message: 'Pošaljite poruku',
    save_job_details: 'Sačuvaj detalje o poslu',
    back: 'Nazad',
    next: 'Dalje'
  },

  authentication_page: {
    signup: 'Prijavite se',
    createaccount: 'Kreirajte nalog',
    company: 'Kompanija',
    jobseeker: 'Tražitelj posla',
    nav_button_create_account: 'Kreirajte nalog',
    next_step_button: 'Sledeći korak',
    login_button: 'Prijavite se',
    reset_button: 'Resetujte lozinku',
    create_account_button: 'Kreirajte nalog',
    continue: 'Nastavi',
    auth_main_title: 'Kreirajte nalog sa HRbee.',
    auth_main_title_desc: 'Izaberite tip korisnika koji vas predstavlja',
    box_jobseeker_title: 'TRAŽITELJ POSLA',
    box_jobseeker_title_desc:
      'Vi ste pojedinac koji traži zaposlenje kod poslodavca.',
    box_jobseeker_title_checbox: 'Ja sam tražitelj posla',
    box_employer_title: 'POSLODAVAC',
    box_employer_title_desc:
      'Vi ste pravno lice koje traži da zaposli tražioce posla.',
    box_employer_title_checbox: 'Ja sam poslodavac',
    account_page_title: 'Informacije o nalogu',
    business_account_page_title: 'Informacije o vašem biznisu',
    account_page_title_desc: 'Molimo vas da navedete podatke o vašem nalogu.',
    jobseeker_account_login_button: 'Prijavite se na nalog',
    terms_conditions_1: 'Pročitao/la sam i prihvatam',
    terms_conditions_2: 'uslove i odredbe',
    auth_bottom_links_forgot_1: 'Zaboravili ste',
    auth_bottom_links_forgot_2: 'lozinku?',
    auth_bottom_links_login_1: 'Nemate nalog? Kreirajte svoj nalog',
    auth_bottom_links_login_2: 'ovde!',
    auth_bottom_links_login_3: 'Već imate nalog i želite da',
    auth_bottom_links_login_4: 'prijavite se!'
  },

  businessCategories: {
    administrate: 'Računovođa',
    agronomi: 'Agronomija',
    arkitekture: 'Arhitektura',
    arsim_edukim: 'Obrazovanje',
    banka_financa: 'Bankarstvo i finansije',
    call_center: 'Call centar',
    hoteleri_turizem: 'Hotelijerstvo i turizam',
    inxhinieri: 'Inženjerstvo',
    juridik: 'Pravo',
    kontabilitet: 'Računovodstvo',
    logjistike: 'Logistika',
    marketing_reklamim: 'Marketing i reklama',
    media: 'Mediji',
    menaxhment: 'Menadžment',
    ndertimtari: 'Građevinarstvo',
    prodhimtari: 'Proizvodnja',
    sherbime_shendetsore: 'Zdravstvene usluge',
    sherbime_klienteve: 'Usluge korisnicima',
    shitje: 'Prodaja',
    sigurime: 'Osiguranje',
    sport: 'Sport',
    teknologji_informative: 'Informacione tehnologije - IT',
    telekomunikacion: 'Telekomunikacije',
    tjera: 'Ostalo',
    trajnim_konsulence: 'Obuka i savetovanje'
  },

  jobseeker_profile_page: {
    tab_experience: 'Iskustvo',
    tab_education: 'Obrazovanje',
    tab_training_courses: 'Obuke/Kursevi',
    tab_languages: 'Jezici',
    tab_computer_skills: 'Računarske veštine',
    tab_other_skills: 'Druge veštine',
    tab_driving_skills: 'Vozačka dozvola'
  },

  package_modules: {
    pricingofpackages: 'Cene paketa',
    package: 'Paket',
    free: 'Besplatno',
    basic: 'Osnovni',
    standart: 'Standardni',
    premium: 'Premium',
    loadingbtn: 'Učitavanje',

    feeds: 'Modul vesti',
    recruitment: 'Modul regrutovanja',
    management: 'Modul menadžmenta',
    workSchedule: 'Modul radnog rasporeda',
    vacation: 'Modul odmora',
    wages: 'Modul plata',
    training: 'Modul obuke',
    performance: 'Modul performansi',
    timeLineProject: 'Modul vremenske linije projekta',
    insurance: 'Modul osiguranja',
    buttonGetStarted: 'Počni',

    nopackages: 'Nema aktivnih paketa za kompanije'
  },

  EducationFieldStudies: {
    Primary: 'Primary',
    music: 'Music',
    dance: 'Dance',
    theatre: 'Theatre',
    film_studies: 'Film Studies',
    fine_arts: 'Fine Arts',
    applied_arts: 'Applied Arts',
    animation: 'Animation',
    calligraphy: 'Calligraphy',
    decorative_arts: 'Decorative Arts',
    mixed_media: 'Mixed Media',
    printmaking: 'Printmaking',
    studio_art: 'Studio Art',
    architecture: 'Architecture',
    design: 'Design',
    history: 'History',
    languages_and_literature: 'Languages And Literature',
    linguistics: 'Linguistics',
    comparative_literature: 'Comparative Literature',
    creative_writing: 'Creative Writing',
    english_literature: 'English Literature',
    history_of_literature: 'History Of Literature',
    literary_theory: 'Literary Theory',
    poetry: 'Poetry',
    world_literature: 'World Literature',
    philosophy: 'Philosophy',
    aesthetics: 'Aesthetics',
    epistemology: 'Epistemology',
    ethics: 'Ethics',
    history_of_philosophy: 'History Of Philosophy',
    logic: 'Logic',
    meta_philosophy: 'Meta Philosophy',
    metaphysics: 'Metaphysics',
    philosophical_movement: 'Philosophical Movement',
    political_philosophy: 'Political Philosophy',
    theology_: 'Theology',
    biblical_studies: 'Biblical Studies',
    religious_studies: 'Religious Studies',
    aramaic: 'Aramaic',
    buddhist_devotion: 'Buddhist Devotion',
    christian_theology: 'Christian Theology',
    hindu_theology: 'Hindu Theology',
    jewish_theology: 'Jewish Theology',
    muslim_theology: 'Muslim Theology',
    social_sciences: 'Social Sciences',
    biological_anthropology: 'Biological Anthropology',
    linguistic_anthropology: 'Linguistic Anthropology',
    cultural_anthropology: 'Cultural Anthropology',
    social_anthropology: 'Social Anthropology',
    archaeology: 'Archaeology',
    agricultural_economics: 'Agricultural Economics',
    anarchist_economics: 'Anarchist Economics',
    applied_economics: 'Applied Economics',
    behavioural_economics: 'Behavioural Economics',
    bioeconomics: 'Bioeconomics',
    complexity_economics: 'Complexity Economics',
    computational_economics: 'Computational Economics',
    consumer_economics: 'Consumer Economics',
    development_economics: 'Development Economics',
    ecological_economics: 'Ecological Economics',
    econometrics: 'Econometrics',
    economic_geography: 'Economic Geography',
    economic_history: 'Economic History',
    economic_sociology: 'Economic Sociology',
    economic_systems: 'Economic Systems',
    energy_economics: 'Energy Economics',
    entrepreneurial_economics: 'Entrepreneurial Economics',
    environmental_economics: 'Environmental Economics',
    evolutionary_economics: 'Evolutionary Economics',
    experimental_economics: 'Experimental Economics',
    feminist_economics: 'Feminist Economics',
    financial_econometrics: 'Financial Econometrics',
    financial_economics: 'Financial Economics',
    green_economics: 'Green Economics',
    economic_growth: 'Economic Growth',
    human_development_theory: 'Human Development Theory',
    industrial_organization: 'Industrial Organization',
    information_economics: 'Information Economics',
    institutional_economics: 'Institutional Economics',
    international_economics: 'International Economics',
    islamic_economics: 'Islamic Economics',
    labor_economics: 'Labor Economics',
    law_and_economics: 'Law And Economics',
    macroeconomics: 'Macroeconomics',
    managerial_economics: 'Managerial Economics',
    marxian_economics: 'Marxian Economics',
    mathematical_economics: 'Mathematical Economics',
    microeconomics: 'Microeconomics',
    monetary_economics: 'Monetary Economics',
    neuroeconomics: 'Neuroeconomics',
    participatory_economics: 'Participatory Economics',
    political_economy: 'Political Economy',
    public_economics: 'Public Economics',
    public_finance: 'Public Finance',
    real_estate_economics: 'Real Estate Economics',
    resource_economics: 'Resource Economics',
    social_choice_theory: 'Social Choice Theory',
    socialist_economics: 'Socialist Economics',
    socioeconomics: 'Socioeconomics',
    transport_economics: 'Transport Economics',
    welfare_economics: 'Welfare Economics',
    marketing: 'Marketing',
    human_geography: 'Human Geography',
    administrative_law: 'Administrative Law',
    canon_law: 'Canon Law',
    civil_law: 'Civil Law',
    comparative_law: 'Comparative Law',
    competition_law: 'Competition Law',
    constitutional_law: 'Constitutional Law',
    criminal_law: 'Criminal Law',
    'sharia|islamic_law': 'Sharia|Islamic Law',
    jewish_law: 'Jewish Law',
    jurisprudence: 'Jurisprudence',
    legal_management: 'Legal Management',
    procedural_law: 'Procedural Law',
    substantive_law: 'Substantive Law',
    politics_of_canada: 'Politics Of Canada',
    civics: 'Civics',
    comparative_politics: 'Comparative Politics',
    european_studies: 'European Studies',
    geopolitics: 'Geopolitics',
    international_relations: 'International Relations',
    international_organizations: 'International Organizations',
    nationalism_studies: 'Nationalism Studies',
    peace_and_conflict_studies: 'Peace And Conflict Studies',
    policy_studies: 'Policy Studies',
    theories_of_political_behavior: 'Theories Of Political Behavior',
    political_culture: 'Political Culture',
    political_history: 'Political History',
    psephology: 'Psephology',
    abnormal_psychology: 'Abnormal Psychology',
    applied_psychology: 'Applied Psychology',
    asian_psychology: 'Asian Psychology',
    biological_psychology: 'Biological Psychology',
    black_psychology: 'Black Psychology',
    clinical_neuropsychology: 'Clinical Neuropsychology',
    clinical_psychology: 'Clinical Psychology',
    cognitive_psychology: 'Cognitive Psychology',
    community_psychology: 'Community Psychology',
    comparative_psychology: 'Comparative Psychology',
    conservation_psychology: 'Conservation Psychology',
    consumer_psychology: 'Consumer Psychology',
    counseling_psychology: 'Counseling Psychology',
    criminal_psychology: 'Criminal Psychology',
    cultural_psychology: 'Cultural Psychology',
    developmental_psychology: 'Developmental Psychology',
    differential_psychology: 'Differential Psychology',
    ecological_psychology: 'Ecological Psychology',
    educational_psychology: 'Educational Psychology',
    environmental_psychology: 'Environmental Psychology',
    evolutionary_psychology: 'Evolutionary Psychology',
    experimental_psychology: 'Experimental Psychology',
    group_dynamics: 'Group Dynamics',
    journal_of_family_psychology: 'Journal Of Family Psychology',
    feminine_psychology: 'Feminine Psychology',
    forensic_developmental_psychology: 'Forensic Developmental Psychology',
    forensic_psychology: 'Forensic Psychology',
    health_psychology: 'Health Psychology',
    humanistic_psychology: 'Humanistic Psychology',
    indigenous_psychology: 'Indigenous Psychology',
    legal_psychology: 'Legal Psychology',
    masculine_psychology: 'Masculine Psychology',
    mathematical_psychology: 'Mathematical Psychology',
    media_psychology: 'Media Psychology',
    medical_psychology: 'Medical Psychology',
    military_psychology: 'Military Psychology',
    descriptive_ethics: 'Descriptive Ethics',
    music_psychology: 'Music Psychology',
    neuropsychology: 'Neuropsychology',
    occupational_health_psychology: 'Occupational Health Psychology',
    occupational_psychology: 'Occupational Psychology',
    industrial_and_organizational_psychology:
      'Industrial And Organizational Psychology',
    parapsychology: 'Parapsychology',
    pediatric_psychology: 'Pediatric Psychology',
    pedology: 'Pedology',
    personality_psychology: 'Personality Psychology',
    phenomenology: 'Phenomenology',
    political_psychology: 'Political Psychology',
    positive_psychology: 'Positive Psychology',
    psychoanalysis: 'Psychoanalysis',
    psychobiology: 'Psychobiology',
    psychology_of_religion: 'Psychology Of Religion',
    psychometrics: 'Psychometrics',
    psychopathology: 'Psychopathology',
    psychophysics: 'Psychophysics',
    quantitative_psychology: 'Quantitative Psychology',
    rehabilitation_psychology_journal: 'Rehabilitation Psychology Journal',
    school_psychology: 'School Psychology',
    social_psychology: 'Social Psychology',
    sport_psychology: 'Sport Psychology',
    traffic_psychology: 'Traffic Psychology',
    transpersonal_psychology: 'Transpersonal Psychology',
    analytical_sociology: 'Analytical Sociology',
    applied_sociology: 'Applied Sociology',
    collective_behavior: 'Collective Behavior',
    chinese_sociology: 'Chinese Sociology',
    community_informatics: 'Community Informatics',
    comparative_sociology: 'Comparative Sociology',
    conflict_theories: 'Conflict Theories',
    criminology: 'Criminology',
    critical_management_studies: 'Critical Management Studies',
    critical_sociology: 'Critical Sociology',
    cultural_sociology: 'Cultural Sociology',
    cultural_studies: 'Cultural Studies',
    demography: 'Demography',
    digital_sociology: 'Digital Sociology',
    dramaturgical_sociology: 'Dramaturgical Sociology',
    educational_sociology: 'Educational Sociology',
    empirical_sociology: 'Empirical Sociology',
    environmental_sociology: 'Environmental Sociology',
    evolutionary_sociology: 'Evolutionary Sociology',
    feminist_sociology: 'Feminist Sociology',
    figurational_sociology: 'Figurational Sociology',
    futures_studies: 'Futures Studies',
    gender_studies: 'Gender Studies',
    historical_sociology: 'Historical Sociology',
    human_ecology: 'Human Ecology',
    humanistic_sociology: 'Humanistic Sociology',
    industrial_sociology: 'Industrial Sociology',
    interactionism: 'Interactionism',
    interpretive_sociology: 'Interpretive Sociology',
    jealousy_sociology: 'Jealousy Sociology',
    macrosociology: 'Macrosociology',
    marxist_sociology: 'Marxist Sociology',
    mathematical_sociology: 'Mathematical Sociology',
    medical_sociology: 'Medical Sociology',
    mesosociology: 'Mesosociology',
    microsociology: 'Microsociology',
    military_sociology: 'Military Sociology',
    natural_resource_sociology: 'Natural Resource Sociology',
    organizational_studies: 'Organizational Studies',
    phenomenological_sociology: 'Phenomenological Sociology',
    policy_sociology: 'Policy Sociology',
    psychoanalytic_sociology: 'Psychoanalytic Sociology',
    science_studies: 'Science Studies',
    sexology: 'Sexology',
    social_capital: 'Social Capital',
    social_change: 'Social Change',
    social_conflict_theory: 'Social Conflict Theory',
    social_control: 'Social Control',
    social_economy: 'Social Economy',
    social_philosophy: 'Social Philosophy',
    social_policy: 'Social Policy',
    social_research: 'Social Research',
    social_stratification: 'Social Stratification',
    social_theory: 'Social Theory',
    social_transformation: 'Social Transformation',
    sociobiology: 'Sociobiology',
    sociocybernetics: 'Sociocybernetics',
    sociolinguistics: 'Sociolinguistics',
    sociological_theory: 'Sociological Theory',
    gerontology: 'Gerontology',
    rural_sociology: 'Rural Sociology',
    sociology_of_art: 'Sociology Of Art',
    societal_and_cultural_aspects_of_autism:
      'Societal And Cultural Aspects Of Autism',
    sociology_of_the_family: 'Sociology Of The Family',
    social_conflict: 'Social Conflict',
    sociology_of_culture: 'Sociology Of Culture',
    sociology_of_the_internet: 'Sociology Of The Internet',
    development_theory: 'Development Theory',
    deviance_sociology: 'Deviance Sociology',
    sociology_of_disaster: 'Sociology Of Disaster',
    sociology_of_education: 'Sociology Of Education',
    sociology_of_emotions: 'Sociology Of Emotions',
    social_studies_of_finance: 'Social Studies Of Finance',
    sociology_of_food: 'Sociology Of Food',
    sociology_of_gender: 'Sociology Of Gender',
    theory_of_generation: 'Theory Of Generation',
    world_systems_theory: 'World Systems Theory',
    political_sociology: 'Political Sociology',
    sociology_of_health_and_illness: 'Sociology Of Health And Illness',
    sociology_of_human_consciousness: 'Sociology Of Human Consciousness',
    sociology_of_immigration: 'Sociology Of Immigration',
    sociology_of_knowledge: 'Sociology Of Knowledge',
    sociology_of_language: 'Sociology Of Language',
    sociology_of_law: 'Sociology Of Law',
    sociology_of_leisure: 'Sociology Of Leisure',
    sociology_of_literature: 'Sociology Of Literature',
    sociomusicology: 'Sociomusicology',
    natural_resource_management: 'Natural Resource Management',
    organizational_behavior: 'Organizational Behavior',
    sociology_of_peace: 'Sociology Of Peace',
    sociology_of_punishment: 'Sociology Of Punishment',
    sociology_of_race_and_ethnic_relations:
      'Sociology Of Race And Ethnic Relations',
    sociology_of_religion: 'Sociology Of Religion',
    'risk|sociology_of_risk': 'Risk|Sociology Of Risk',
    sociology_of_scientific_knowledge: 'Sociology Of Scientific Knowledge',
    social_movement: 'Social Movement',
    sociology_of_space: 'Sociology Of Space',
    sociology_of_sport: 'Sociology Of Sport',
    'science,_technology_and_society': 'Science, Technology And Society',
    sociology_of_terrorism: 'Sociology Of Terrorism',
    sociology_of_the_body: 'Sociology Of The Body',
    sociology_of_the_history_of_science: 'Sociology Of The History Of Science',
    structural_sociology: 'Structural Sociology',
    theoretical_sociology: 'Theoretical Sociology',
    urban_sociology: 'Urban Sociology',
    victimology: 'Victimology',
    visual_sociology: 'Visual Sociology',
    aerobiology: 'Aerobiology',
    anatomy: 'Anatomy',
    biochemistry: 'Biochemistry',
    bioinformatics: 'Bioinformatics',
    biophysics: 'Biophysics',
    biotechnology: 'Biotechnology',
    botany: 'Botany',
    cell_biology: 'Cell Biology',
    chronobiology: 'Chronobiology',
    computational_biology: 'Computational Biology',
    cryobiology: 'Cryobiology',
    developmental_biology: 'Developmental Biology',
    ecology: 'Ecology',
    endocrinology: 'Endocrinology',
    evolutionary_biology: 'Evolutionary Biology',
    genetics: 'Genetics',
    histology: 'Histology',
    human_biology: 'Human Biology',
    immunology: 'Immunology',
    limnology: 'Limnology',
    linnaean_taxonomy: 'Linnaean Taxonomy',
    marine_biology: 'Marine Biology',
    mathematical_biology: 'Mathematical Biology',
    microbiology: 'Microbiology',
    molecular_biology: 'Molecular Biology',
    mycology: 'Mycology',
    neuroscience: 'Neuroscience',
    nutrition: 'Nutrition',
    paleobiology: 'Paleobiology',
    parasitology: 'Parasitology',
    pathology: 'Pathology',
    physiology: 'Physiology',
    structural_biology: 'Structural Biology',
    systematics: 'Systematics',
    systems_biology: 'Systems Biology',
    virology: 'Virology',
    xenobiology: 'Xenobiology',
    zoology: 'Zoology',
    agrochemistry: 'Agrochemistry',
    analytical_chemistry: 'Analytical Chemistry',
    astrochemistry: 'Astrochemistry',
    atmospheric_chemistry: 'Atmospheric Chemistry',
    chemical_biology: 'Chemical Biology',
    chemical_engineering: 'Chemical Engineering',
    cheminformatics: 'Cheminformatics',
    computational_chemistry: 'Computational Chemistry',
    cosmochemistry: 'Cosmochemistry',
    electrochemistry: 'Electrochemistry',
    environmental_chemistry: 'Environmental Chemistry',
    femtochemistry: 'Femtochemistry',
    flavor: 'Flavor',
    flow_chemistry: 'Flow Chemistry',
    geochemistry: 'Geochemistry',
    green_chemistry: 'Green Chemistry',
    histochemistry: 'Histochemistry',
    hydrogenation: 'Hydrogenation',
    immunochemistry: 'Immunochemistry',
    inorganic_chemistry: 'Inorganic Chemistry',
    marine_chemistry: 'Marine Chemistry',
    mathematical_chemistry: 'Mathematical Chemistry',
    mechanochemistry: 'Mechanochemistry',
    medicinal_chemistry: 'Medicinal Chemistry',
    molecular_mechanics: 'Molecular Mechanics',
    nanotechnology: 'Nanotechnology',
    natural_product_chemistry: 'Natural Product Chemistry',
    neurochemistry: 'Neurochemistry',
    oenology: 'Oenology',
    organic_chemistry: 'Organic Chemistry',
    organometallic_chemistry: 'Organometallic Chemistry',
    petrochemistry: 'Petrochemistry',
    pharmacology: 'Pharmacology',
    photochemistry_: 'Photochemistry',
    physical_chemistry: 'Physical Chemistry',
    physical_organic_chemistry: 'Physical Organic Chemistry',
    phytochemistry: 'Phytochemistry',
    polymer_chemistry: 'Polymer Chemistry',
    quantum_chemistry: 'Quantum Chemistry',
    radiochemistry: 'Radiochemistry',
    solid_state_chemistry: 'Solid State Chemistry',
    sonochemistry: 'Sonochemistry',
    supramolecular_chemistry: 'Supramolecular Chemistry',
    surface_chemistry: 'Surface Chemistry',
    synthetic_chemistry: 'Synthetic Chemistry',
    theoretical_chemistry: 'Theoretical Chemistry',
    thermochemistry: 'Thermochemistry',
    edaphology: 'Edaphology',
    environmental_science: 'Environmental Science',
    gemology: 'Gemology',
    geodesy: 'Geodesy',
    physical_geography: 'Physical Geography',
    geophysics: 'Geophysics',
    paleontology: 'Paleontology',
    astrobiology: 'Astrobiology',
    astronomy: 'Astronomy',
    astrophysics: 'Astrophysics',
    interstellar_medium: 'Interstellar Medium',
    direct_numerical_simulation: 'Direct Numerical Simulation',
    physical_cosmology: 'Physical Cosmology',
    'star|stellar_astrophysics': 'Star|Stellar Astrophysics',
    planetary_science: 'Planetary Science',
    _physics_: 'Physics',
    acoustics: 'Acoustics',
    applied_physics: 'Applied Physics',
    'atomic,_molecular': 'Atomic, Molecular',
    computational_physics: 'Computational Physics',
    condensed_matter_physics: 'Condensed Matter Physics',
    cryogenics: 'Cryogenics',
    electromagnetism: 'Electromagnetism',
    elementary_particle_physics: 'Elementary Particle Physics',
    experimental_physics: 'Experimental Physics',
    fluid_dynamics: 'Fluid Dynamics',
    mathematical_physics: 'Mathematical Physics',
    mechanics: 'Mechanics',
    medical_physics: 'Medical Physics',
    molecular_physics: 'Molecular Physics',
    newtons_laws_of_motion: 'Newtons Laws Of Motion',
    nuclear_physics: 'Nuclear Physics',
    optics: 'Optics',
    plasma_physics: 'Plasma Physics',
    quantum_physics: 'Quantum Physics',
    solid_mechanics: 'Solid Mechanics',
    solid_state_physics: 'Solid State Physics',
    statistical_mechanics: 'Statistical Mechanics',
    theoretical_physics: 'Theoretical Physics',
    thermodynamics: 'Thermodynamics',
    vehicle_dynamics: 'Vehicle Dynamics',
    computer_science: 'Computer Science',
    logic_in_computer_science: 'Logic In Computer Science',
    algorithms: 'Algorithms',
    artificial_intelligence: 'Artificial Intelligence',
    data_structures: 'Data Structures',
    computer_architecture: 'Computer Architecture',
    computer_graphics: 'Computer Graphics',
    computer_networking: 'Computer Networking',
    high_availability: 'High Availability',
    medicine: 'Medicine',
    professions: 'Professions',
    distributed_computing: 'Distributed Computing',
    human_computer_interaction: 'Human Computer Interaction',
    operating_systems: 'Operating Systems',
    parallel_computing: 'Parallel Computing',
    programming_languages: 'Programming Languages',
    quantum_computing: 'Quantum Computing',
    software_engineering: 'Software Engineering',
    theory_of_computation: 'Theory Of Computation',
    very_large_scale_integration: 'Very Large Scale Integration',
    mathematics: 'Mathematics',
    foundations_of_mathematics: 'Foundations Of Mathematics',
    algebra: 'Algebra',
    mathematical_analysis: 'Mathematical Analysis',
    probability_theory: 'Probability Theory',
    topology: 'Topology',
    number_theory: 'Number Theory',
    approximation_theory: 'Approximation Theory',
    combinatorics: 'Combinatorics',
    cryptography: 'Cryptography',
    dynamical_systems: 'Dynamical Systems',
    game_theory: 'Game Theory',
    graph_theory: 'Graph Theory',
    information_theory: 'Information Theory',
    numerical_analysis: 'Numerical Analysis',
    operations_research: 'Operations Research',
    statistics: 'Statistics',
    astrostatistics: 'Astrostatistics',
    biostatistics: 'Biostatistics',
    bioengineering: 'Bioengineering',
    catalysis: 'Catalysis',
    materials_engineering: 'Materials Engineering',
    molecular_engineering: 'Molecular Engineering',
    polymer_engineering: 'Polymer Engineering',
    process_design: 'Process Design',
    process_engineering: 'Process Engineering',
    reaction_engineering: 'Reaction Engineering',
    transport_phenomena: 'Transport Phenomena',
    coastal_engineering: 'Coastal Engineering',
    earthquake_engineering: 'Earthquake Engineering',
    ecological_engineering: 'Ecological Engineering',
    environmental_engineering: 'Environmental Engineering',
    geotechnical_engineering: 'Geotechnical Engineering',
    hydraulic_engineering_: 'Hydraulic Engineering',
    mining_engineering: 'Mining Engineering',
    transportation_engineering: 'Transportation Engineering',
    structural_engineering: 'Structural Engineering',
    structural_mechanics: 'Structural Mechanics',
    surveying: 'Surveying',
    instructional_design: 'Instructional Design',
    human_performance_technology: 'Human Performance Technology',
    knowledge_management: 'Knowledge Management',
    computer_engineering: 'Computer Engineering',
    control_engineering: 'Control Engineering',
    electronic_engineering: 'Electronic Engineering',
    engineering_physics: 'Engineering Physics',
    mechatronics: 'Mechatronics',
    power_engineering: 'Power Engineering',
    robotics: 'Robotics',
    semiconductors: 'Semiconductors',
    telecommunications_engineering: 'Telecommunications Engineering',
    biomaterials: 'Biomaterials',
    ceramic_engineering: 'Ceramic Engineering',
    crystallography: 'Crystallography',
    nanomaterials: 'Nanomaterials',
    photonics: 'Photonics',
    metallurgy: 'Metallurgy',
    polymer_science: 'Polymer Science',
    aerospace_engineering: 'Aerospace Engineering',
    acoustical_engineering: 'Acoustical Engineering',
    automotive_engineering: 'Automotive Engineering',
    biomedical_engineering: 'Biomedical Engineering',
    continuum_mechanics: 'Continuum Mechanics',
    fluid_mechanics: 'Fluid Mechanics',
    heat_transfer: 'Heat Transfer',
    industrial_engineering: 'Industrial Engineering',
    manufacturing_engineering: 'Manufacturing Engineering',
    marine_propulsion: 'Marine Propulsion',
    mass_transfer: 'Mass Transfer',
    nanoengineering: 'Nanoengineering',
    offshore_construction: 'Offshore Construction',
    optical_engineering: 'Optical Engineering',
    vehicle_engineering: 'Vehicle Engineering',
    chaos_theory: 'Chaos Theory',
    complex_system: 'Complex System',
    complex_systems: 'Complex Systems',
    conceptual_systems: 'Conceptual Systems',
    control_theory: 'Control Theory',
    cybernetics: 'Cybernetics',
    network_science: 'Network Science',
    system_dynamics: 'System Dynamics',
    systems_ecology: 'Systems Ecology',
    systems_engineering: 'Systems Engineering',
    systems_psychology: 'Systems Psychology',
    systems_theory: 'Systems Theory',
    systems_theory_in_anthropology: 'Systems Theory In Anthropology',
    medicine_and_health: 'Medicine And Health',
    alternative_medicine: 'Alternative Medicine',
    clinical_laboratory_sciences: 'Clinical Laboratory Sciences',
    clinical_physiology: 'Clinical Physiology',
    dentistry: 'Dentistry',
    dermatology: 'Dermatology',
    emergency_medicine: 'Emergency Medicine',
    geriatrics: 'Geriatrics',
    gynaecology: 'Gynaecology',
    health_informatics: 'Health Informatics',
    hematology: 'Hematology',
    infectious_disease: 'Infectious Disease',
    intensive_care_medicine: 'Intensive Care Medicine',
    internal_medicine: 'Internal Medicine',
    medical_toxicology: 'Medical Toxicology',
    music_therapy: 'Music Therapy',
    nursing: 'Nursing',
    dietetics: 'Dietetics',
    obstetrics: 'Obstetrics',
    occupational_hygiene: 'Occupational Hygiene',
    occupational_therapy: 'Occupational Therapy',
    occupational_toxicology: 'Occupational Toxicology',
    ophthalmology: 'Ophthalmology',
    optometry: 'Optometry',
    otolaryngology: 'Otolaryngology',
    pediatrics: 'Pediatrics',
    pharmaceutical_sciences: 'Pharmaceutical Sciences',
    physical_fitness: 'Physical Fitness',
    physical_therapy: 'Physical Therapy',
    physiotherapy: 'Physiotherapy',
    podiatry: 'Podiatry',
    preventive_healthcare: 'Preventive Healthcare',
    primary_care: 'Primary Care',
    psychiatry: 'Psychiatry',
    psychology: 'Psychology',
    public_health: 'Public Health',
    radiology: 'Radiology',
    recreational_therapy: 'Recreational Therapy',
    physical_medicine_and_rehabilitation:
      'Physical Medicine And Rehabilitation',
    respiratory_therapy: 'Respiratory Therapy',
    sleep_medicine: 'Sleep Medicine',
    speech_language_pathology: 'Speech Language Pathology',
    sports_medicine: 'Sports Medicine',
    surgery: 'Surgery',
    traditional_medicine: 'Traditional Medicine',
    urology: 'Urology',
    veterinary_medicine: 'Veterinary Medicine',
    other: 'Other'
  },

  EducationDegrees: {
    ps: 'Osnovna škola (OS)',
    hs: 'Srednja škola (SS)',
    prs: 'Stručna škola (STS)',
    st: 'Student (ST)',
    ba: 'Diplomirani (BA)',
    ma: 'Master (MA)',
    phd: 'Doktor nauka (PhD)',
    other: 'Drugo'
  }
}
